/* AURA BEAUTY — 交互脚本 */
(function () {
  'use strict';

  /* 0. 滚动条宽度：右侧出血区块靠它换算「可用视口宽」，避免 100vw 把页面撑出横向滚动 */
  (function () {
    var root = document.documentElement;
    var raf = 0;
    function set() {
      raf = 0;
      var w = window.innerWidth - root.clientWidth;
      root.style.setProperty('--sbw', (w > 0 ? w : 0) + 'px');
    }
    function schedule() { if (!raf) raf = window.requestAnimationFrame(set); }
    set();
    window.addEventListener('resize', schedule);
    window.addEventListener('orientationchange', schedule);
  })();

  /* 1. 首屏 Banner 幻灯片 */
  document.querySelectorAll('[data-slider]').forEach(function (root) {
    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-slide]'));
    if (slides.length < 2) return;

    var thumbs   = Array.prototype.slice.call(root.querySelectorAll('[data-goto]'));
    var counter  = root.querySelector('[data-current]');
    var barWrap  = root.querySelector('.wb-hero__progress');
    var bar      = root.querySelector('[data-progress]');
    var autoplay = root.getAttribute('data-autoplay') === 'true';
    var dur      = Math.max(3, parseFloat(root.getAttribute('data-interval')) || 6) * 1000;
    var reduce   = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var index = 0, timer = null, paused = false;

    root.style.setProperty('--dur', dur + 'ms');

    function pad(n) { return (n < 10 ? '0' : '') + n; }

    function render() {
      slides.forEach(function (s, k) { s.classList.toggle('is-active', k === index); });
      thumbs.forEach(function (t, k) {
        t.classList.toggle('is-active', k === index);
        t.setAttribute('aria-selected', k === index ? 'true' : 'false');
      });
      if (counter) counter.textContent = pad(index + 1);
    }

    function runBar() {
      if (!barWrap) return;
      barWrap.classList.remove('is-running');
      void barWrap.offsetWidth; /* 强制重排，让动画从头再跑 */
      if (autoplay && !paused && !reduce) barWrap.classList.add('is-running');
    }

    function stop() { if (timer) { clearTimeout(timer); timer = null; } }

    function start() {
      stop();
      if (!autoplay || paused || reduce) return;
      timer = setTimeout(function () { go(index + 1); }, dur);
    }

    function go(n) {
      index = (n + slides.length) % slides.length;
      render();
      runBar();
      start();
    }

    thumbs.forEach(function (t) {
      t.addEventListener('click', function () {
        go(parseInt(t.getAttribute('data-goto'), 10) || 0);
      });
    });

    var prev = root.querySelector('[data-prev]');
    var next = root.querySelector('[data-next]');
    if (prev) prev.addEventListener('click', function () { go(index - 1); });
    if (next) next.addEventListener('click', function () { go(index + 1); });

    /* 悬停暂停，移开后重新计时 */
    if (window.matchMedia('(hover: hover)').matches) {
      root.addEventListener('mouseenter', function () {
        paused = true; stop();
        if (bar) bar.style.animationPlayState = 'paused';
      });
      root.addEventListener('mouseleave', function () {
        paused = false;
        if (bar) bar.style.animationPlayState = '';
        runBar(); start();
      });
    }

    /* 移动端左右滑动 */
    var tx = 0, ty = 0;
    root.addEventListener('touchstart', function (e) {
      tx = e.touches[0].clientX;
      ty = e.touches[0].clientY;
    }, { passive: true });
    root.addEventListener('touchend', function (e) {
      var dx = e.changedTouches[0].clientX - tx;
      var dy = e.changedTouches[0].clientY - ty;
      if (Math.abs(dx) > 46 && Math.abs(dx) > Math.abs(dy)) {
        go(index + (dx < 0 ? 1 : -1));
      }
    }, { passive: true });

    /* 切到后台标签页时停掉，避免回来一次跳好几张 */
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) stop(); else start();
    });

    render();
    runBar();
    start();
  });

  /* 2. 头部滚动状态 */
  var header = document.querySelector('.wb-hd');
  if (header) {
    var onScroll = function () {
      header.classList.toggle('is-stuck', window.scrollY > 8);
    };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });

    /* 吸顶兜底：CSS sticky 依赖「祖先不是滚动容器」，一旦被外层 wrapper / overflow 破坏，
       顶栏就会跟着页面滚走。这里检测到这种情况才切到 fixed + 占位块，正常情况永远不触发。 */
    var pinSpacer = null;
    var pinned = false;
    var hdDocTop = 0; // 顶栏在文档中的原始位置，0 表示还没测到

    var setPinned = function (on) {
      if (on === pinned) return;
      pinned = on;
      if (on) {
        if (!pinSpacer) {
          pinSpacer = document.createElement('div');
          pinSpacer.className = 'wb-hd__spacer';
          pinSpacer.setAttribute('aria-hidden', 'true');
          header.parentNode.insertBefore(pinSpacer, header);
        }
        pinSpacer.style.height = header.offsetHeight + 'px';
        header.classList.add('is-pinned');
      } else {
        header.classList.remove('is-pinned');
        if (pinSpacer) pinSpacer.style.height = '0px';
      }
    };

    var stickGuard = function () {
      if (!hdDocTop) {
        var top = header.getBoundingClientRect().top;
        if (top >= -2) return; // sticky 生效中，不测不干预
        hdDocTop = Math.round(window.scrollY + top);
      }
      setPinned(window.scrollY >= hdDocTop);
    };
    window.addEventListener('scroll', stickGuard, { passive: true });
    window.addEventListener('resize', function () {
      if (pinned && pinSpacer) pinSpacer.style.height = header.offsetHeight + 'px';
    }, { passive: true });
  }

  /* 3. 滚动淡入 */
  var reveals = document.querySelectorAll('.wb-reveal');
  if (reveals.length) {
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            e.target.classList.add('is-in');
            io.unobserve(e.target);
          }
        });
      }, { rootMargin: '0px 0px -10% 0px', threshold: 0.06 });
      reveals.forEach(function (el) { io.observe(el); });
    } else {
      reveals.forEach(function (el) { el.classList.add('is-in'); });
    }
  }

  /* 4. 前后对比拖拽 */
  document.querySelectorAll('[data-ba]').forEach(function (stage) {
    var dragging = false;

    function set(clientX) {
      var r = stage.getBoundingClientRect();
      var p = ((clientX - r.left) / r.width) * 100;
      p = Math.max(3, Math.min(97, p));
      stage.style.setProperty('--split', p + '%');
    }

    stage.addEventListener('pointerdown', function (e) {
      dragging = true;
      try { stage.setPointerCapture(e.pointerId); } catch (err) {}
      set(e.clientX);
    });
    stage.addEventListener('pointermove', function (e) {
      if (dragging) set(e.clientX);
    });
    ['pointerup', 'pointercancel', 'pointerleave'].forEach(function (ev) {
      stage.addEventListener(ev, function () { dragging = false; });
    });

    /* 键盘无障碍 */
    stage.setAttribute('tabindex', '0');
    stage.addEventListener('keydown', function (e) {
      var cur = parseFloat(getComputedStyle(stage).getPropertyValue('--split')) || 50;
      if (e.key === 'ArrowLeft') { stage.style.setProperty('--split', Math.max(3, cur - 4) + '%'); e.preventDefault(); }
      if (e.key === 'ArrowRight') { stage.style.setProperty('--split', Math.min(97, cur + 4) + '%'); e.preventDefault(); }
    });
  });

  /* 5. 色号切换 */
  document.querySelectorAll('[data-shade]').forEach(function (dot) {
    dot.addEventListener('click', function () {
      var stage = dot.closest('.wb-shades__stage');
      if (!stage) return;
      stage.querySelectorAll('[data-shade]').forEach(function (d) { d.classList.remove('is-active'); });
      dot.classList.add('is-active');

      var nameEl = stage.querySelector('[data-shade-name]');
      var descEl = stage.querySelector('[data-shade-desc]');
      var numEl = stage.querySelector('[data-shade-counter]');

      if (nameEl) nameEl.style.opacity = 0;
      if (descEl) descEl.style.opacity = 0;
      setTimeout(function () {
        if (nameEl) { nameEl.textContent = dot.dataset.name; nameEl.style.opacity = 1; }
        if (descEl) { descEl.textContent = dot.dataset.desc; descEl.style.opacity = 1; }
        if (numEl) numEl.textContent = dot.dataset.no;
      }, 150);
    });
  });

  /* 7. 商品货架：标签页切换 + 横滑进度条 */
  document.querySelectorAll('[data-shelf]').forEach(function (shelf) {
    var tabs = Array.prototype.slice.call(shelf.querySelectorAll('[data-shelf-tab]'));
    var panels = Array.prototype.slice.call(shelf.querySelectorAll('[data-shelf-panel]'));

    /* 每个标签页各自绑定滚动条 */
    panels.forEach(function (panel) {
      var rail = panel.querySelector('[data-shelf-rail]');
      var bar = panel.querySelector('[data-shelf-bar]');
      var thumb = panel.querySelector('[data-shelf-thumb]');
      if (!rail || !bar || !thumb) return;

      function update() {
        var max = rail.scrollWidth - rail.clientWidth;
        if (max <= 1) {
          bar.classList.add('is-static');
          rail.classList.remove('is-scrollable');
          return;
        }
        bar.classList.remove('is-static');
        rail.classList.add('is-scrollable');
        var w = Math.max(14, (rail.clientWidth / rail.scrollWidth) * 100);
        thumb.style.width = w + '%';
        thumb.style.left = (rail.scrollLeft / max) * (100 - w) + '%';
      }

      rail.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(update);

      panel.wbUpdateBar = update;
      update();

      /* 进度条拖动横滑：点轨道跳到该处，按住滑块平移 */
      var barDown = false, barOffset = 0, barMax = 0, barW = 1;
      function clamp01(n) { return n < 0 ? 0 : n > 1 ? 1 : n; }

      bar.addEventListener('pointerdown', function (e) {
        if (e.pointerType !== 'mouse' || e.button !== 0) return;
        barMax = rail.scrollWidth - rail.clientWidth;
        if (barMax <= 1) return;

        var rect = bar.getBoundingClientRect();
        barW = Math.min(0.999, rail.clientWidth / rail.scrollWidth);
        var ratio = clamp01((e.clientX - rect.left) / rect.width);
        var thumbLeft = (rail.scrollLeft / barMax) * (1 - barW);

        if (ratio >= thumbLeft && ratio <= thumbLeft + barW) {
          barOffset = ratio - thumbLeft;            /* 按住滑块：保持相对位置 */
        } else {
          barOffset = barW / 2;                     /* 点轨道：滑块跳到指针处 */
          rail.scrollLeft = clamp01((ratio - barOffset) / (1 - barW)) * barMax;
        }

        barDown = true;
        bar.classList.add('is-dragging');
        rail.classList.add('is-dragging');
        try { bar.setPointerCapture(e.pointerId); } catch (err) {}
        e.preventDefault();
      });

      bar.addEventListener('pointermove', function (e) {
        if (!barDown) return;
        var rect = bar.getBoundingClientRect();
        var ratio = clamp01((e.clientX - rect.left) / rect.width);
        rail.scrollLeft = clamp01((ratio - barOffset) / (1 - barW)) * barMax;
        e.preventDefault();
      });

      ['pointerup', 'pointercancel'].forEach(function (ev) {
        bar.addEventListener(ev, function () {
          if (!barDown) return;
          barDown = false;
          bar.classList.remove('is-dragging');
          rail.classList.remove('is-dragging');
        });
      });

      /* 鼠标拖拽横滑（触摸走原生滚动） */
      var down = false, moved = false, startX = 0, startLeft = 0;
      rail.addEventListener('pointerdown', function (e) {
        if (e.pointerType !== 'mouse' || e.button !== 0) return;
        down = true; moved = false;
        startX = e.clientX; startLeft = rail.scrollLeft;
        /* 不阻止默认行为，Chrome 会开启选择/原生拖拽手势并抛出 pointercancel */
        e.preventDefault();
      });
      rail.addEventListener('dragstart', function (e) { e.preventDefault(); });
      rail.addEventListener('pointermove', function (e) {
        if (!down) return;
        var dx = e.clientX - startX;
        if (!moved && Math.abs(dx) > 5) {
          moved = true;
          rail.classList.add('is-dragging');
          try { rail.setPointerCapture(e.pointerId); } catch (err) {}
        }
        if (moved) { rail.scrollLeft = startLeft - dx; e.preventDefault(); }
      });
      ['pointerup', 'pointercancel'].forEach(function (ev) {
        rail.addEventListener(ev, function () {
          down = false;
          rail.classList.remove('is-dragging');
        });
      });
      /* 拖过之后不要再触发卡片链接 */
      rail.addEventListener('click', function (e) {
        if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; }
      }, true);
    });

    /* 标签切换 */
    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var n = tab.getAttribute('data-shelf-tab');
        tabs.forEach(function (t) {
          var on = t === tab;
          t.classList.toggle('is-active', on);
          t.setAttribute('aria-selected', on ? 'true' : 'false');
        });
        panels.forEach(function (p) {
          var on = p.getAttribute('data-shelf-panel') === n;
          p.hidden = !on;
          if (on) {
            p.classList.remove('is-entering');
            void p.offsetWidth;
            p.classList.add('is-entering');
            if (p.wbUpdateBar) p.wbUpdateBar();
          }
        });
      });
    });
  });

  /* SKU 缩略图行：放不下时横向滑动（边缘渐隐提示） */
  document.querySelectorAll('.wb-item__dots').forEach(function (dots) {
    function sync() {
      var max = dots.scrollWidth - dots.clientWidth;
      dots.classList.toggle('is-scrollable', max > 1);
      dots.classList.remove('is-from-start', 'is-from-mid', 'is-from-end');
      if (max <= 1) return;
      if (dots.scrollLeft <= 1) dots.classList.add('is-from-start');
      else if (dots.scrollLeft >= max - 1) dots.classList.add('is-from-end');
      else dots.classList.add('is-from-mid');
    }

    sync();
    dots.addEventListener('scroll', sync, { passive: true });
    window.addEventListener('resize', sync);

    /* 关键：<a>/<img> 的原生拖拽会抢走指针，直接触发 pointercancel 让拖拽失效 */
    dots.addEventListener('dragstart', function (e) { e.preventDefault(); });
    dots.addEventListener('selectstart', function (e) {
      if (dots.scrollWidth - dots.clientWidth > 1) e.preventDefault();
    });

    var down = false, moved = false, startX = 0, startLeft = 0, pid = null;

    /* 鼠标拖拽横滑；触摸/触控板走原生滚动，不拦截 */
    dots.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse' || e.button !== 0) return;
      if (dots.scrollWidth - dots.clientWidth <= 1) return;
      e.stopPropagation();                 /* 不冒泡给货架，避免整排卡片跟着滑 */
      down = true; moved = false;
      startX = e.clientX; startLeft = dots.scrollLeft; pid = e.pointerId;
    });

    dots.addEventListener('pointermove', function (e) {
      if (!down) return;
      var dx = e.clientX - startX;
      if (!moved && Math.abs(dx) > 5) {
        moved = true;
        dots.classList.add('is-dragging');
        try { dots.setPointerCapture(pid); } catch (err) {}
      }
      if (!moved) return;
      dots.scrollLeft = startLeft - dx;
      e.preventDefault();
      e.stopPropagation();
    });

    ['pointerup', 'pointercancel'].forEach(function (ev) {
      dots.addEventListener(ev, function (e) {
        if (!down) return;
        down = false;
        dots.classList.remove('is-dragging');
        e.stopPropagation();
        setTimeout(function () { moved = false; }, 0);
      });
    });

    /* 拖拽松手后紧跟的 click 吃掉，避免滑一下就误跳商品详情 */
    dots.addEventListener('click', function (e) {
      if (moved) { e.preventDefault(); e.stopPropagation(); }
    }, true);
  });

  /* 内容 + 视频：播放/暂停、滚出视口暂停、触屏卡片点开展信息 */
  document.querySelectorAll('[data-cwv]').forEach(function (root) {
    var video = root.querySelector('.wb-cwv__media video');
    var btn = root.querySelector('[data-cwv-toggle]');

    if (video && btn) {
      var userPaused = false;

      function paint() {
        var playing = !video.paused && !video.ended;
        btn.setAttribute('aria-pressed', playing ? 'true' : 'false');
        btn.setAttribute('aria-label', playing ? '暂停视频' : '播放视频');
      }

      btn.addEventListener('click', function () {
        if (video.paused) { userPaused = false; video.play().catch(function () {}); }
        else { userPaused = true; video.pause(); }
        paint();
      });
      video.addEventListener('play', paint);
      video.addEventListener('pause', paint);
      /* 首帧到了但没自动播起来（低电量模式等），按钮状态要跟上 */
      video.addEventListener('loadeddata', paint);
      paint();

      /* 滚出视口就停，回来再续；用户手动暂停过的不自动恢复 */
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          entries.forEach(function (e) {
            if (e.isIntersecting) {
              if (!userPaused) video.play().catch(function () {});
            } else if (!video.paused) {
              video.pause();
            }
          });
        }, { threshold: 0.15 }).observe(video);
      }
    }

    /* 触屏没有 hover：第一次点先展开商品名/价格，再点才跳详情 */
    var touchOnly = window.matchMedia('(hover: none)');
    root.querySelectorAll('.wb-cwv__chip').forEach(function (chip) {
      chip.addEventListener('click', function (e) {
        if (!touchOnly.matches) return;
        if (!chip.classList.contains('is-open')) {
          e.preventDefault();
          root.querySelectorAll('.wb-cwv__chip.is-open').forEach(function (c) {
            if (c !== chip) c.classList.remove('is-open');
          });
          chip.classList.add('is-open');
        }
      });
    });
  });

  /* 9. 造型时刻：桌面滚动驱动切换，移动端横滑进度 */
  document.querySelectorAll('[data-looks]').forEach(function (root) {
    var stage  = root.querySelector('[data-looks-stage]');
    var items  = Array.prototype.slice.call(root.querySelectorAll('[data-looks-item]'));
    var panels = Array.prototype.slice.call(root.querySelectorAll('[data-looks-panel]'));
    var tabs   = Array.prototype.slice.call(root.querySelectorAll('[data-looks-tab]'));
    var N = items.length;
    if (!stage || !N) return;

    var deskQ   = window.matchMedia('(min-width: 1100px)');
    var motionQ = window.matchMedia('(prefers-reduced-motion: reduce)');
    var active  = -1;
    var rafId   = null;
    var lastW   = window.innerWidth;
    var radius  = parseFloat(getComputedStyle(root).getPropertyValue('--looks-radius')) || 18;

    /* 位置关键帧，索引 = distance + 2（distance 是「该图相对当前进度的格数」）
       同演示站 bfe--scroll_opposite：上一张（-1）停在**右上**小图、下一张（+1）停在
       **左下**小图，两张都保持不透明 —— 点选项时上一张飞向右上、下一张从左下顶上，
       大小两张同屏呼应。只有 ±2 才收到 0 透明度，且必须对角分开：
       两侧同边的话 -0.5 和 +0.5 会精确重叠成双影。
       位移/缩放从 CSS 变量读，窄视口可以在样式表里单独收一点，避免小图压到右侧文案。 */
    var cs = getComputedStyle(root);
    function vnum(name, fb) {
      var v = parseFloat(cs.getPropertyValue(name));
      return isFinite(v) ? v : fb;
    }
    var FRAMES = [];
    function buildFrames() {
      var SX = vnum('--looks-side-sx', 0.29), SY = vnum('--looks-side-sy', 0.22);
      var SIDE_X = vnum('--looks-side-x', 68.8), SIDE_Y = vnum('--looks-side-y', -39.6);
      var PARK = vnum('--looks-side-park', 0.7), OVER = 1.35;
      FRAMES = [
        { x: SIDE_X * OVER,  y: SIDE_Y * OVER,  sx: SX * PARK, sy: SY * PARK, o: 0 },
        { x: SIDE_X,         y: SIDE_Y,         sx: SX,        sy: SY,        o: 1 },
        { x: 0,              y: 0,              sx: 1,         sy: 1,         o: 1 },
        { x: -SIDE_X,        y: -SIDE_Y,        sx: SX,        sy: SY,        o: 1 },
        { x: -SIDE_X * OVER, y: -SIDE_Y * OVER, sx: SX * PARK, sy: SY * PARK, o: 0 }
      ];
    }
    buildFrames();

    function clamp(v, a, b) { return v < a ? a : (v > b ? b : v); }
    function ease(t) { return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2; }
    function lerp(a, b, t) { return a + (b - a) * t; }

    function slot(d) {
      var pos = clamp(d + 2, 0, 4);
      var lo = Math.floor(pos);
      var hi = Math.min(lo + 1, 4);
      var t = ease(clamp(pos - lo, 0, 1));
      var a = FRAMES[lo], b = FRAMES[hi];
      return {
        x: lerp(a.x, b.x, t), y: lerp(a.y, b.y, t),
        sx: lerp(a.sx, b.sx, t), sy: lerp(a.sy, b.sy, t),
        o: lerp(a.o, b.o, t)
      };
    }

    function paintItem(item, d) {
      var s = slot(d);
      if (s.o < 0.01) {
        item.style.visibility = 'hidden';
        item.style.opacity = '0';
        return;
      }
      item.style.visibility = 'visible';
      item.style.opacity = String(s.o);
      item.style.zIndex = String(Math.round(100 - Math.abs(d) * 10));
      item.style.transform = 'translate3d(' + s.x + '%, ' + s.y + '%, 0) scale(' + s.sx + ',' + s.sy + ')';
      /* 缩放会把圆角一起压扁，按缩放比反算才不会让小图变圆片 */
      item.style.borderRadius = (radius / s.sx) + 'px / ' + (radius / s.sy) + 'px';
      /* sx/sy 不等比（.29 / .22），图会被横向压扁。图片自身再反向补偿一次，
         视觉上始终是等比裁切（同演示站 renderItem）。 */
      var img = item.firstElementChild;
      if (img && img.tagName === 'IMG') {
        var cover = Math.max(s.sx, s.sy);
        img.style.transform = 'scale(' + (cover / s.sx) + ',' + (cover / s.sy) + ')';
      }
    }

    function paintPanel(panel, d) {
      var fade = clamp(1 - Math.abs(d) / 0.5, 0, 1);
      panel.style.opacity = String(ease(fade));
      panel.style.transform = 'translate3d(0,' + (clamp(d, -1, 1) * 20) + 'px,0)';
      panel.style.visibility = fade < 0.01 ? 'hidden' : 'visible';
    }

    function setActive(index) {
      if (index === active) return;
      active = index;
      tabs.forEach(function (tab, i) {
        var on = i === index;
        tab.classList.toggle('is-active', on);
        if (on) tab.setAttribute('aria-current', 'true');
        else tab.removeAttribute('aria-current');
      });
      items.forEach(function (it, i) { it.classList.toggle('is-active', i === index); });
      panels.forEach(function (pn, i) {
        var on = i === index;
        pn.classList.toggle('is-active', on);
        pn.inert = !on;
        if (on) pn.removeAttribute('aria-hidden');
        else pn.setAttribute('aria-hidden', 'true');
      });
    }

    function scrollable() { return stage.offsetHeight - window.innerHeight; }

    function render() {
      var s = scrollable();
      var p = 0;
      if (s > 0 && N > 1) {
        p = clamp(-stage.getBoundingClientRect().top / s, 0, 1) * N - 0.5;
        p = clamp(p, 0, N - 1);
      }
      items.forEach(function (it, i) { paintItem(it, i - p); });
      panels.forEach(function (pn, i) { paintPanel(pn, i - p); });
      setActive(Math.round(p));
    }

    function onScroll() {
      if (rafId) return;
      rafId = requestAnimationFrame(function () {
        rafId = null;
        /* 视口宽度变了（跨 1199/1200 时段落会换一套 --looks-side-x），关键帧要重读 */
        if (Math.abs(window.innerWidth - lastW) > 1) { lastW = window.innerWidth; buildFrames(); }
        render();
      });
    }

    /* 点左侧选项的跳转：原生 scrollTo({behavior:'smooth'}) 只用 ~300ms 就走完全程，
       跨格时画面是一闪而过。这里自己跑缓动，时长按跨格数加长（单格约 1.1s，最多 2s），
       接近演示站 lenis duration=1 的手感；用户自己滚/触摸/按键时立刻让出控制权。 */
    var jumpRaf = null;
    var jumpPrevBehavior = null;
    function easeInOut(t) { return t < 0.5 ? 2 * t * t : 1 - Math.pow(-2 * t + 2, 2) / 2; }
    function stopJump() {
      if (jumpRaf) { cancelAnimationFrame(jumpRaf); jumpRaf = null; }
      if (jumpPrevBehavior !== null) {
        document.documentElement.style.scrollBehavior = jumpPrevBehavior;
        jumpPrevBehavior = null;
      }
    }
    function jumpTo(index) {
      var s = scrollable();
      if (!deskQ.matches || motionQ.matches || s <= 0 || N <= 1) return;
      var from = window.scrollY;
      var top = stage.getBoundingClientRect().top + window.scrollY + ((index + 0.5) / N) * s;
      if (Math.abs(top - from) < 2) return;
      var span = Math.abs(index - clamp(Math.round(active < 0 ? 0 : active), 0, N - 1));
      var dur = clamp(900 + 260 * span, 900, 2000);
      var t0 = (window.performance && performance.now) ? performance.now() : Date.now();
      stopJump();
      /* 全局有 html{scroll-behavior:smooth}，不临时关掉的话，逐帧 scrollTo 会被浏览器
         再平滑一次 —— 结果是一秒只挪一百像素的慢爬，最后猛地窜过去。 */
      jumpPrevBehavior = document.documentElement.style.scrollBehavior || '';
      document.documentElement.style.scrollBehavior = 'auto';
      function step(now) {
        var k = clamp((now - t0) / dur, 0, 1);
        window.scrollTo(0, from + (top - from) * easeInOut(k));
        if (k < 1) jumpRaf = requestAnimationFrame(step);
        else { jumpRaf = null; stopJump(); }
      }
      jumpRaf = requestAnimationFrame(step);
    }

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () { jumpTo(Number(tab.dataset.index) || 0); });
    });
    ['wheel', 'touchstart', 'keydown'].forEach(function (ev) {
      window.addEventListener(ev, stopJump, { passive: true });
    });

    function resetStyles() {
      items.forEach(function (it) {
        it.removeAttribute('style');
        it.classList.remove('is-active');
        /* 图片上的反向补偿缩放也要清掉，否则切回移动端会一直带形变 */
        var im = it.firstElementChild;
        if (im && im.style) im.style.transform = '';
      });
      panels.forEach(function (pn) {
        pn.removeAttribute('style');
        pn.classList.remove('is-active');
      });
      active = -1;
    }

    function enterMode() {
      window.removeEventListener('scroll', onScroll);
      window.removeEventListener('resize', onScroll);
      if (rafId) { cancelAnimationFrame(rafId); rafId = null; }
      stopJump();

      if (deskQ.matches && !motionQ.matches) {
        window.addEventListener('scroll', onScroll, { passive: true });
        window.addEventListener('resize', onScroll, { passive: true });
        render();
      } else {
        resetStyles();
        setActive(0);
      }
    }

    if (deskQ.addEventListener) {
      deskQ.addEventListener('change', enterMode);
      motionQ.addEventListener('change', enterMode);
    }
    enterMode();

    /* 移动端横滑进度条 */
    var track = root.querySelector('[data-looks-track]');
    var bar   = root.querySelector('[data-looks-bar]');
    var thumb = bar ? bar.querySelector('i') : null;
    if (track && thumb && N > 1) {
      var syncBar = function () {
        var max = track.scrollWidth - track.clientWidth;
        var w = Math.min(1, track.clientWidth / Math.max(1, track.scrollWidth));
        var tw = Math.max(0.16, w);
        thumb.style.width = (tw * 100) + '%';
        thumb.style.transform = 'translateX(' + (max > 0 ? (1 - tw) * track.clientWidth * (track.scrollLeft / max) : 0) + 'px)';
      };
      track.addEventListener('scroll', syncBar, { passive: true });
      window.addEventListener('resize', syncBar);
      syncBar();
    } else if (bar) {
      bar.style.display = 'none';
    }
  });

  /* 10. 精选快购：缩略图切换 / 数量步进 / AJAX 加购 */
  document.querySelectorAll('[data-quick]').forEach(function (root) {
    var stage  = root.querySelector('[data-quick-stage]');
    var slides = stage ? Array.prototype.slice.call(stage.querySelectorAll('[data-quick-slide]')) : [];
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-quick-thumb]'));
    var input  = root.querySelector('[data-quick-input]');
    var minus  = root.querySelector('[data-quick-step="-1"]');
    var plus   = root.querySelector('[data-quick-step="1"]');
    var form   = root.querySelector('[data-quick-form]');
    var submit = root.querySelector('[data-quick-submit]');
    var label  = root.querySelector('[data-quick-label]');

    thumbs.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var i = Number(btn.dataset.index) || 0;
        slides.forEach(function (s, k) { s.classList.toggle('is-active', k === i); });
        thumbs.forEach(function (b, k) {
          var on = k === i;
          b.classList.toggle('is-active', on);
          if (on) b.setAttribute('aria-current', 'true');
          else b.removeAttribute('aria-current');
        });
      });
    });

    function setQty(n) {
      var q = Math.round(n);
      if (!isFinite(q) || q < 1) q = 1;
      if (q > 99) q = 99;
      if (input) input.value = String(q);
      if (minus) minus.disabled = q <= 1;
      return q;
    }
    function currentQty() { return setQty(parseInt(input && input.value, 10) || 1); }

    if (minus) minus.addEventListener('click', function () { setQty(currentQty() - 1); });
    if (plus)  plus.addEventListener('click',  function () { setQty(currentQty() + 1); });
    if (input) {
      input.addEventListener('input', function () {
        input.value = input.value.replace(/[^\d]/g, '');
      });
      input.addEventListener('blur', function () { setQty(parseInt(input.value, 10) || 1); });
      input.addEventListener('keydown', function (e) {
        if (e.key === 'Enter') { e.preventDefault(); currentQty(); }
      });
    }

    /* 购物袋角标：header 只在 item_count > 0 时渲染那个 span，第一次加购需要自己补一个 */
    function syncCartCount() {
      if (!window.fetch) return;
      fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var el = document.querySelector('.wb-hd__count');
          if (!el) {
            var link = document.querySelector('.wb-hd__act--cart');
            if (!link || !cart.item_count) return;
            el = document.createElement('span');
            el.className = 'wb-hd__count';
            link.appendChild(el);
          }
          el.textContent = String(cart.item_count);
          el.hidden = cart.item_count === 0;
        })
        .catch(function () {});
    }

    if (form && submit) {
      form.addEventListener('submit', function (e) {
        /* 没有 fetch 的老浏览器直接走原生提交 */
        if (!window.fetch || !window.FormData) return;
        e.preventDefault();
        if (submit.disabled || submit.classList.contains('is-busy')) return;

        var idle = label ? label.textContent : '';
        submit.classList.add('is-busy');
        submit.disabled = true;
        if (label) label.textContent = '加入中…';

        fetch(form.getAttribute('action') + '.js', {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: new FormData(form),
        })
          .then(function (r) {
            return r.json().then(function (j) { if (!r.ok) throw j; return j; });
          })
          .then(function () {
            submit.classList.add('is-done');
            if (label) label.textContent = '已加入购物车 ✓';
            syncCartCount();
            setTimeout(function () {
              submit.classList.remove('is-done', 'is-busy');
              submit.disabled = false;
              if (label) label.textContent = idle;
            }, 2000);
          })
          .catch(function () {
            submit.classList.remove('is-busy');
            submit.disabled = false;
            if (label) label.textContent = '加入失败，请重试';
            setTimeout(function () { if (label) label.textContent = idle; }, 2400);
          });
      });
    }
  });

  /* 11. 分步妆容：点步骤切图，露出的下一张从右侧滑进来 */
  document.querySelectorAll('[data-steps]').forEach(function (root) {
    var nav     = root.querySelector('.wb-steps__nav');
    var items   = [].slice.call(root.querySelectorAll('.wb-steps__nav-item'));
    var tabs    = [].slice.call(root.querySelectorAll('[data-steps-tab]'));
    var track   = root.querySelector('[data-steps-track]');
    var slides  = [].slice.call(root.querySelectorAll('[data-steps-slide]'));
    if (!track || !tabs.length || !slides.length) return;

    var active = 0;
    var warmed = {};

    /* 轨道里的图都在可视区外，lazy 不会自己加载。
       每次切换预热「当前 / 前后各一张」，点下一步时图已经在缓存里，不会空白。 */
    function warm(i) {
      var slide = slides[i];
      if (!slide || warmed[i]) return;
      var img = slide.querySelector('.wb-steps__pic');
      if (!img || !img.getAttribute('src')) return;
      warmed[i] = 1;
      var pre = new Image();
      pre.src = img.getAttribute('src');
    }

    /* 一步的位移 = 图上宽度 + 图间距；用真实测量值，避免 flex-basis 里 calc 换算出偏差 */
    function stepSize() {
      var r = slides[0].getBoundingClientRect();
      var mr = parseFloat(getComputedStyle(slides[0]).marginRight) || 0;
      return r.width + mr;
    }

    function baseX() { return -active * stepSize(); }

    function setX(x, animate) {
      if (!animate) track.style.transition = 'none';
      track.style.transform = 'translateX(' + x + 'px)';
      if (!animate) {
        /* 强制回流，让无动画的那一帧立即生效，再把过渡装回去 */
        void track.offsetWidth;
        track.style.transition = '';
      }
    }

    function render(animate) {
      setX(baseX(), animate);
      warm(active); warm(active + 1); warm(active - 1);

      tabs.forEach(function (tab, i) {
        var on = i === active;
        tab.classList.toggle('is-active', on);
        tab.setAttribute('aria-selected', on ? 'true' : 'false');
        tab.tabIndex = on ? 0 : -1;
        if (items[i]) items[i].classList.toggle('is-active', on);
      });
      slides.forEach(function (s, i) {
        var on = i === active;
        s.classList.toggle('is-active', on);
        s.setAttribute('aria-hidden', on ? 'false' : 'true');
      });

      /* 窄屏步骤条是横向滚动的，保证当前项在视野里 */
      if (nav && nav.scrollWidth > nav.clientWidth + 1) {
        var cur = tabs[active];
        var left = cur.offsetLeft - nav.offsetLeft;
        if (left < nav.scrollLeft || left + cur.offsetWidth > nav.scrollLeft + nav.clientWidth) {
          nav.scrollTo({ left: left - 16, behavior: 'smooth' });
        }
      }
    }

    function go(i, animate) {
      var next = Math.max(0, Math.min(slides.length - 1, i));
      if (next === active) { render(animate); return; }
      active = next;
      render(animate);
    }

    tabs.forEach(function (tab, i) {
      tab.addEventListener('click', function () { go(i, true); });
    });

    /* 按住鼠标（或手指）左右拖动：跟手位移，松手按拖动距离和甩动速度决定翻不翻页 */
    var viewport = root.querySelector('.wb-steps__viewport');
    var drag = null;
    var swallowClick = false;
    var swallowTimer = null;

    function endDrag(e) {
      if (!drag) return;
      if (e && e.pointerId !== undefined && e.pointerId !== drag.id) return;
      var d = drag;
      drag = null;
      if (!d.live) return;

      viewport.classList.remove('is-dragging');
      track.classList.remove('is-dragging');

      /* 拖完松手不该顺手点开图上的 SHOP NOW，吞掉紧随其后的一次 click */
      swallowClick = true;
      clearTimeout(swallowTimer);
      swallowTimer = setTimeout(function () { swallowClick = false; }, 350);

      var th = Math.max(48, viewport.clientWidth * 0.12);
      var v = d.dx / Math.max(1, (e && e.timeStamp ? e.timeStamp : d.t) - d.t0); /* px/ms，负=向左 */
      if (d.dx < -th || v < -0.55) go(active + 1, true);
      else if (d.dx > th || v > 0.55) go(active - 1, true);
      else render(true); /* 没拖够，回弹到原位 */
    }

    if (viewport && slides.length > 1) {
      viewport.addEventListener('dragstart', function (e) { e.preventDefault(); });

      viewport.addEventListener('pointerdown', function (e) {
        if (e.pointerType === 'mouse' && e.button !== 0) return;
        drag = {
          id: e.pointerId, x0: e.clientX, y0: e.clientY,
          base: baseX(), dx: 0, live: false,
          t0: e.timeStamp, t: e.timeStamp
        };
      });

      viewport.addEventListener('pointermove', function (e) {
        if (!drag || e.pointerId !== drag.id) return;
        var dx = e.clientX - drag.x0;
        var dy = e.clientY - drag.y0;

        if (!drag.live) {
          /* 先判方向：竖向手势让给页面滚动，横向超过 8px 才接管 */
          if (Math.abs(dx) < 8) return;
          if (Math.abs(dx) <= Math.abs(dy)) { drag = null; return; }
          drag.live = true;
          viewport.classList.add('is-dragging');
          track.classList.add('is-dragging');
          try { viewport.setPointerCapture(e.pointerId); } catch (err) {}
        }

        e.preventDefault();
        drag.dx = dx;
        drag.t = e.timeStamp;

        var x = drag.base + dx;
        var min = -(slides.length - 1) * stepSize();
        /* 首尾越界只给一点阻尼，别让整排图被拖离舞台 */
        if (x > 0) x *= 0.32;
        else if (x < min) x = min + (x - min) * 0.32;
        track.style.transform = 'translateX(' + x + 'px)';
      });

      viewport.addEventListener('pointerup', endDrag);
      viewport.addEventListener('pointercancel', endDrag);

      viewport.addEventListener('click', function (e) {
        if (!swallowClick) return;
        e.preventDefault();
        e.stopPropagation();
        swallowClick = false;
      }, true);
    }

    /* 键盘：上下/左右方向键在步骤间移动（WAI-ARIA tabs 模式） */
    nav.addEventListener('keydown', function (e) {
      var key = e.key;
      var delta = (key === 'ArrowDown' || key === 'ArrowRight') ? 1
                : (key === 'ArrowUp' || key === 'ArrowLeft') ? -1 : 0;
      if (!delta) return;
      e.preventDefault();
      var next = (active + delta + slides.length) % slides.length;
      go(next, true);
      tabs[next].focus();
    });

    var rz = null;
    window.addEventListener('resize', function () {
      clearTimeout(rz);
      rz = setTimeout(function () { render(false); }, 140);
    });

    render(false);

    /* 首屏稳定后逐张空闲预取，用户滑到哪张都已经是缓存 */
    var warmIdx = 1;
    function warmNext() {
      if (warmIdx >= slides.length) return;
      warm(warmIdx++);
      if ('requestIdleCallback' in window) requestIdleCallback(warmNext, { timeout: 2500 });
      else setTimeout(warmNext, 700);
    }
    if ('requestIdleCallback' in window) requestIdleCallback(warmNext, { timeout: 2500 });
    else setTimeout(warmNext, 1200);
  });

  /* 6. 移动端菜单 */
  var burger = document.querySelector('[data-menu-open]');
  var drawer = document.querySelector('[data-drawer]');
  if (burger && drawer) {
    burger.addEventListener('click', function (e) {
      e.preventDefault();
      drawer.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    });
    function close() {
      drawer.classList.remove('is-open');
      document.body.style.overflow = '';
    }
    drawer.querySelectorAll('[data-menu-close], a').forEach(function (b) {
      b.addEventListener('click', close);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') close();
    });
  }

  /* ---------- 12. 前后对比滑块 ---------- */
  /* 舞台里铺了一个透明的 input[type=range]，拖动/方向键都由它驱动，
     这里只负责把 value 写回 --ba-pos，裁剪、分隔线、标签透明度全靠 CSS 跟着算 */
  (function () {
    document.querySelectorAll('[data-ba]').forEach(function (el) {
      var range = el.querySelector('.wb-ba__range');
      if (!range) return;
      var apply = function () {
        var v = Number(range.value) || 0;
        el.style.setProperty('--ba-pos', v + '%');
        el.style.setProperty('--ba-p', (v / 100).toFixed(4));
      };
      range.addEventListener('input', apply);
      range.addEventListener('change', apply);
      apply();
    });
  })();

  /* ---------- 13. 找色号 · 三步筛选 ---------- */
  /* 演示站是靠自定义标签 + 集合标签路由实现的：
     选中「类别 + 妆效」拼成 /collections/all/标签1+标签2，价格走 filter.v.price.gte/lte。
     额外加了一层保底：点击「Show My Results」时先查一下这组标签有没有货，
     完全匹配为空就逐级放宽（先去掉妆效、再去掉价格），避免落到空集合页。 */
  (function () {
    var roots = document.querySelectorAll('[data-find]');
    if (!roots.length) return;

    [].forEach.call(roots, function (root) {
      var form = root.querySelector('[data-find-form]');
      if (!form) return;
      var section = root.closest('.wb-find') || document;
      var steps = [].slice.call(root.querySelectorAll('[data-find-step]'));
      if (!steps.length) return;
      var psteps = [].slice.call(section.querySelectorAll('[data-find-progress-step]'));
      var nextBtn = root.querySelector('[data-find-next]');
      var prevBtn = root.querySelector('[data-find-prev]');
      var notice = root.querySelector('[data-find-notice]');
      var baseUrl = (root.getAttribute('data-base-url') || '/collections/all').replace(/\/+$/, '');
      var sortBy = root.getAttribute('data-sort-by') || '';
      var current = 0;
      var picked = [];
      var cache = {};

      function handleize(v) {
        return String(v || '').trim().toLowerCase()
          .replace(/['"’]/g, '')
          .replace(/[^a-z0-9]+/g, '-')
          .replace(/^-+|-+$/g, '');
      }

      function tagsOf(opt) {
        return (opt.getAttribute('data-tags') || opt.getAttribute('data-tag') || '')
          .split('||')
          .map(function (t) { return t.trim(); })
          .filter(Boolean);
      }

      function tagPath(tags) {
        var out = [];
        (tags || []).forEach(function (t) {
          var h = handleize(t);
          if (h && out.indexOf(h) < 0) out.push(h);
        });
        return out.join('+');
      }

      function urlFor(tags, price) {
        var path = tagPath(tags);
        var url = new URL(path ? baseUrl + '/' + path : baseUrl, window.location.origin);
        var params = new URLSearchParams();
        if (sortBy) params.set('sort_by', sortBy);
        if (price && price.min) params.set('filter.v.price.gte', price.min);
        if (price && price.max) params.set('filter.v.price.lte', price.max);
        url.search = params.toString();
        return url.toString();
      }

      function productsFor(tags) {
        var key = tagPath(tags);
        if (cache[key]) return cache[key];
        var ctrl = window.AbortController ? new AbortController() : null;
        var timer = ctrl ? setTimeout(function () { ctrl.abort(); }, 2500) : 0;
        var endpoint = (key ? baseUrl + '/' + key : baseUrl) + '/products.json?limit=250';
        cache[key] = fetch(endpoint, ctrl ? { signal: ctrl.signal } : undefined)
          .then(function (r) { return r.ok ? r.json() : null; })
          .then(function (j) {
            clearTimeout(timer);
            return j && j.products ? j.products : null;
          })
          .catch(function () {
            clearTimeout(timer);
            return null;
          });
        return cache[key];
      }

      function countInPrice(list, price) {
        if (!price || (!price.min && !price.max)) return list.length;
        var min = price.min ? parseFloat(price.min) : -Infinity;
        var max = price.max ? parseFloat(price.max) : Infinity;
        return list.filter(function (p) {
          return (p.variants || []).some(function (v) {
            var amount = parseFloat(v.price);
            return v.available !== false && amount >= min && amount <= max;
          });
        }).length;
      }

      function select(index, opt) {
        [].forEach.call(steps[index].querySelectorAll('[data-find-option]'), function (el) {
          el.setAttribute('aria-checked', el === opt ? 'true' : 'false');
        });
        picked[index] = {
          tags: tagsOf(opt),
          min: opt.getAttribute('data-min-price') || '',
          max: opt.getAttribute('data-max-price') || ''
        };
        nextBtn.disabled = false;
      }

      function syncProgress() {
        psteps.forEach(function (el, i) {
          el.classList.toggle('is-active', i === current);
          el.classList.toggle('is-done', i < current);
          if (i === current) el.setAttribute('aria-current', 'step');
          else el.removeAttribute('aria-current');
        });
        var strip = psteps[0] && psteps[0].parentElement;
        var active = psteps[current];
        if (!strip || !active) return;
        if (strip.scrollWidth <= strip.clientWidth + 1) return;
        var left = active.offsetLeft - (strip.clientWidth - active.offsetWidth) / 2;
        strip.scrollTo({
          left: Math.max(0, Math.min(left, strip.scrollWidth - strip.clientWidth)),
          behavior: 'smooth'
        });
      }

      function render() {
        steps.forEach(function (step, i) {
          var on = i === current;
          step.classList.toggle('is-active', on);
          step.hidden = !on;
        });
        prevBtn.hidden = current === 0;
        nextBtn.disabled = !picked[current];
        nextBtn.textContent = current === steps.length - 1
          ? (nextBtn.getAttribute('data-finish-label') || 'Next')
          : (nextBtn.getAttribute('data-next-label') || 'Next');
        syncProgress();
      }

      function center() {
        var el = steps[current];
        if (!el) return;
        var box = el.getBoundingClientRect();
        if (box.height > window.innerHeight) return;
        var delta = box.top + box.height / 2 - window.innerHeight / 2;
        if (Math.abs(delta) > 24) window.scrollBy({ top: delta, behavior: 'smooth' });
      }

      function submit() {
        var cat = picked[0] ? picked[0].tags : [];
        var fin = picked[1] ? picked[1].tags : [];
        var price = picked[2] || {};
        var full = cat.concat(fin);

        nextBtn.disabled = true;
        nextBtn.textContent = nextBtn.getAttribute('data-loading-label') || '';

        Promise.all([productsFor(full), productsFor(cat)]).then(function (res) {
          var both = res[0];
          var only = res[1];
          /* 查不到数据（比如站点还在密码保护里）就按原样跳，不拦用户 */
          if (!both && !only) return urlFor(full, price);
          if (both && countInPrice(both, price)) return urlFor(full, price);
          if (only && countInPrice(only, price)) return urlFor(cat, price);
          if (both && both.length) return urlFor(full, {});
          if (only && only.length) return urlFor(cat, {});
          return urlFor([], {});
        }).then(function (url) {
          if (notice) notice.hidden = false;
          window.location.assign(url);
        }).catch(function () {
          window.location.assign(urlFor(full, price));
        });
      }

      steps.forEach(function (step, index) {
        [].forEach.call(step.querySelectorAll('[data-find-option]'), function (opt) {
          opt.addEventListener('click', function () { select(index, opt); });
        });
      });

      psteps.forEach(function (el, i) {
        el.addEventListener('click', function () {
          if (i >= current) return; /* 还没走到的步骤不可点 */
          current = i;
          render();
          center();
        });
      });

      nextBtn.addEventListener('click', function () {
        if (nextBtn.disabled) return;
        if (current === steps.length - 1) { submit(); return; }
        current += 1;
        render();
        center();
      });

      prevBtn.addEventListener('click', function () {
        if (current === 0) return;
        current -= 1;
        render();
        center();
      });

      form.addEventListener('keydown', function (e) {
        if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;
        var opts = [].slice.call(steps[current].querySelectorAll('[data-find-option]'));
        var at = -1;
        opts.forEach(function (o, i) { if (o.getAttribute('aria-checked') === 'true') at = i; });
        var to = e.key === 'ArrowRight' ? at + 1 : (at < 0 ? 0 : at - 1);
        if (!opts[to]) return;
        e.preventDefault();
        opts[to].focus();
        select(current, opts[to]);
      });

      render();
    });
  })();
})();

/* ===== 14. 妆容热点 · GET THE LOOK ===== */
(function () {
  var sections = document.querySelectorAll('[data-hotspot]');
  if (!sections.length) return;

  Array.prototype.forEach.call(sections, function (section) {
    var pins = [].slice.call(section.querySelectorAll('[data-hotspot-pin]'));
    var items = [].slice.call(section.querySelectorAll('[data-hotspot-item]'));
    var media = section.querySelector('[data-hotspot-media]');
    if (!pins.length || !items.length) return;

    var active = 0;
    pins.forEach(function (pin, i) {
      if (pin.classList.contains('is-active')) active = i;
    });

    function setInteractive(item, on) {
      [].slice.call(item.querySelectorAll('a')).forEach(function (a) {
        var isThumb = a.classList.contains('wb-hotspot__thumb');
        a.tabIndex = on && !isThumb ? 0 : -1;
        if (on) a.removeAttribute('aria-disabled');
        else a.setAttribute('aria-disabled', 'true');
      });
    }

    function setActive(index) {
      if (index === active || !items[index]) return;
      active = index;
      pins.forEach(function (pin, i) {
        var on = i === index;
        pin.classList.toggle('is-active', on);
        pin.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      items.forEach(function (item, i) {
        var on = i === index;
        item.classList.toggle('is-active', on);
        setInteractive(item, on);
      });
    }

    pins.forEach(function (pin) {
      pin.addEventListener('click', function () {
        setActive(Number(pin.getAttribute('data-index')));
      });
    });

    items.forEach(function (item, i) {
      setInteractive(item, i === active);
    });

    if (!media) return;
    if (!('IntersectionObserver' in window)) {
      media.classList.add('is-in-view');
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        media.classList.add('is-in-view');
        io.unobserve(entry.target);
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -40px 0px' });
    io.observe(media);
  });
})();

/* ===== 15. 视频墙 · GLAM IN ACTION ===== */
(function () {
  var sections = document.querySelectorAll('[data-glam]');
  if (!sections.length) return;

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  Array.prototype.forEach.call(sections, function (section) {
    var grid = section.querySelector('[data-glam-grid]');
    var cards = [].slice.call(section.querySelectorAll('[data-glam-card]'));
    if (!cards.length) return;

    function videoOf(card) { return card.querySelector('video'); }

    // 按钮状态跟着视频真实状态走，自动播放被浏览器拦下时也不会显示错图标
    function sync(card) {
      var v = videoOf(card);
      var btn = card.querySelector('[data-glam-toggle]');
      if (!v) return;
      var playing = !v.paused && !v.ended;
      card.setAttribute('data-autoplaying', playing ? 'true' : 'false');
      if (!btn) return;
      btn.setAttribute('aria-pressed', playing ? 'true' : 'false');
      btn.setAttribute('aria-label', playing ? btn.getAttribute('data-label-pause') : btn.getAttribute('data-label-play'));
    }

    function play(v) {
      if (!v || !v.paused) return;
      var p = v.play();
      if (p && p.catch) p.catch(function () {});
    }

    cards.forEach(function (card) {
      var v = videoOf(card);
      var btn = card.querySelector('[data-glam-toggle]');
      if (!v) return;
      v.muted = true;
      v.setAttribute('muted', '');
      v.addEventListener('play', function () { sync(card); });
      v.addEventListener('pause', function () { sync(card); });
      v.addEventListener('ended', function () { sync(card); });
      if (btn) {
        btn.addEventListener('click', function () {
          if (v.paused) {
            card.removeAttribute('data-manual-pause');
            play(v);
          } else {
            card.setAttribute('data-manual-pause', 'true');
            v.pause();
          }
        });
      }
      sync(card);
    });

    function playAll() {
      cards.forEach(function (card) {
        if (card.hasAttribute('data-manual-pause')) return;
        play(videoOf(card));
      });
    }

    function pauseAll() {
      cards.forEach(function (card) {
        var v = videoOf(card);
        if (v && !v.paused) v.pause();
      });
    }

    // 进入视口四个一起播，离开就停，省流量也省电
    if (!('IntersectionObserver' in window)) {
      playAll();
    } else {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) playAll();
          else pauseAll();
        });
      }, { threshold: 0.15 });
      io.observe(section);
    }

    // 入场：卡片依次浮起
    if (grid && !reduceMotion && 'IntersectionObserver' in window) {
      grid.classList.add('is-reveal');
      var items = [].slice.call(grid.children);
      var rio = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          items.forEach(function (el) { el.classList.add('is-in'); });
          rio.unobserve(entry.target);
        });
      }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
      rio.observe(grid);
    }

    // 桌面端按住拖动横向滚动（触屏用原生）
    if (grid) {
      var down = false, moved = false, startX = 0, startLeft = 0;
      grid.addEventListener('pointerdown', function (e) {
        if (e.pointerType === 'touch' || e.button !== 0) return;
        down = true; moved = false;
        startX = e.clientX; startLeft = grid.scrollLeft;
      });
      window.addEventListener('pointermove', function (e) {
        if (!down) return;
        var dx = e.clientX - startX;
        if (!moved && Math.abs(dx) > 6) {
          moved = true;
          grid.classList.add('is-dragging');
        }
        if (moved) grid.scrollLeft = startLeft - dx;
      });
      window.addEventListener('pointerup', function () {
        if (!down) return;
        down = false;
        if (!moved) return;
        grid.classList.remove('is-dragging');
        // 拖完这一次不要顺带触发商品跳转
        var kill = function (ev) { ev.preventDefault(); ev.stopPropagation(); };
        grid.addEventListener('click', kill, true);
        window.setTimeout(function () { grid.removeEventListener('click', kill, true); }, 0);
      });
    }
  });
})();

/* ===== 16. 客户反馈 · WHAT OUR CUSTOMERS SAY ===== */
(function () {
  var roots = document.querySelectorAll('[data-say]');
  if (!roots.length) return;

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  Array.prototype.forEach.call(roots, function (root) {
    var grid = root.querySelector('[data-say-grid]');
    var bar = root.querySelector('[data-say-bar]');
    var thumb = root.querySelector('[data-say-thumb]');
    if (!grid) return;

    var maxScroll = 0;
    var thumbW = 1; // 滑块占轨道宽度的比例 = 可见比例

    function render() {
      if (!thumb) return;
      var p = maxScroll > 0 ? grid.scrollLeft / maxScroll : 0;
      p = Math.min(1, Math.max(0, p));
      thumb.style.width = thumbW * 100 + '%';
      thumb.style.left = p * (1 - thumbW) * 100 + '%';
    }

    function measure() {
      maxScroll = grid.scrollWidth - grid.clientWidth;
      thumbW = maxScroll > 4 ? Math.max(grid.clientWidth / grid.scrollWidth, 0.12) : 1;
      if (bar) bar.hidden = maxScroll <= 4;
      render();
    }

    grid.addEventListener('scroll', function () {
      window.requestAnimationFrame(render);
    }, { passive: true });

    // 松手后按卡片吸附：先临时关掉 CSS 吸附做平滑落位，再交还给 CSS
    // （不这样做的话，恢复 scroll-snap-type 的瞬间会被强制弹回上一个吸附点）
    var settleT = 0;
    var animId = 0;          // 进度条缓动动画句柄
    var targetScroll = 0;    // 进度条缓动目标
    // 在 0、step、2*step … 与 maxScroll 之间取离当前最近的一个
    function snapTarget(from, step) {
      var best = 0, bestD = Math.abs(from);
      for (var p = step; p < maxScroll; p += step) {
        var d = Math.abs(p - from);
        if (d < bestD) { bestD = d; best = p; }
      }
      if (Math.abs(maxScroll - from) < bestD) best = maxScroll;
      return Math.round(Math.min(maxScroll, Math.max(0, best)));
    }
    function snapStep() {
      var first = grid.firstElementChild;
      if (!first) return 0;
      var gap = parseFloat(window.getComputedStyle(grid).columnGap) || 0;
      return first.getBoundingClientRect().width + gap;
    }
    function settle() {
      // 先停掉进度条那套缓动：否则它下一帧仍会把 scrollLeft 往旧目标拉，
      // 吸附就被拽回去、停在两张卡中间
      if (animId) { window.cancelAnimationFrame(animId); animId = 0; }
      var step = snapStep();
      if (step <= 0 || maxScroll <= 4) {
        targetScroll = grid.scrollLeft;
        grid.style.scrollSnapType = '';
        return;
      }
      // 吸附点在「每张卡起点」和「滚动末端」里挑最近的：
      // 只按 k*step 取整的话，滑到最右端会被拽回倒数第二张卡，看着像被弹回去
      var target = snapTarget(grid.scrollLeft, step);
      targetScroll = target; // 缓动目标同步过来，避免下次拖动从旧值起跳
      grid.style.scrollSnapType = 'none';
      grid.scrollTo({ left: target, behavior: reduceMotion ? 'auto' : 'smooth' });
      window.clearTimeout(settleT);
      settleT = window.setTimeout(function () { grid.style.scrollSnapType = ''; }, 700);
    }

    // 拖动 / 点击进度条
    // 鼠标在条上挪 1px，内容要滚动 maxScroll / 滑块行程 那么远（常常是 8~14 倍），
    // 直接把 scrollLeft 赋成目标值会非常冲、很难精确停在某张卡上。
    // 这里改成先记目标位置，再用动画每帧追一段，视觉上慢下来也顺滑。
    if (bar) {
      var barDown = false;
      var barMoved = false;      // 这一次按下有没有真的拖动过（区分「点一下」和「拖」）
      var pendingSettle = false;
      var FOLLOW = 0.25; // 每帧追 25% 的剩余距离：约 8~10 帧（0.15s）跟上，比瞬跳柔和很多又不掉队

      function stepAnim() {
        animId = 0;
        var diff = targetScroll - grid.scrollLeft;
        // 阈值必须大于 1.5：scrollLeft 会被浏览器取整到整像素，剩余距离小于 2px 时
        // 每帧那点增量会被取整吃掉，位置永不收敛、rAF 空转，松手后的吸附也就永远不触发
        if (Math.abs(diff) < 1.5) {
          grid.scrollLeft = targetScroll;
          if (pendingSettle) { pendingSettle = false; settle(); }
          return;
        }
        grid.scrollLeft += diff * FOLLOW;
        animId = window.requestAnimationFrame(stepAnim);
      }

      function glideTo(x) {
        // 目标取整：scrollLeft 本身就是整数值，带小数的目标会永远差一点点
        targetScroll = Math.round(Math.min(maxScroll, Math.max(0, x)));
        if (!animId) animId = window.requestAnimationFrame(stepAnim);
      }

      var ratioFromX = function (clientX) {
        var r = bar.getBoundingClientRect();
        var travel = r.width * (1 - thumbW);
        if (travel <= 0) return 0;
        // 以滑块中心对齐鼠标，点击轨道中点就跳到中点
        var x = clientX - r.left - (r.width * thumbW) / 2;
        return Math.min(1, Math.max(0, x / travel));
      };

      bar.addEventListener('pointerdown', function (e) {
        if (e.pointerType === 'mouse' && e.button !== 0) return;
        barDown = true;
        barMoved = false;
        pendingSettle = false;
        try { bar.setPointerCapture(e.pointerId); } catch (err) {}
        grid.style.scrollSnapType = 'none';
        glideTo(ratioFromX(e.clientX) * maxScroll);
        e.preventDefault();
      });

      bar.addEventListener('pointermove', function (e) {
        if (!barDown) return;
        barMoved = true;
        glideTo(ratioFromX(e.clientX) * maxScroll);
      });

      var barUp = function (e) {
        if (!barDown) return;
        barDown = false;
        // 只是点了一下（没拖）：让缓动滑到目标再吸附，不要一松手就跳到就近的卡
        // 真拖过：就地吸附，别再继续追旧目标
        if (!barMoved && animId) pendingSettle = true;
        else settle();
        try { if (e && e.pointerId != null) bar.releasePointerCapture(e.pointerId); } catch (err) {}
      };
      bar.addEventListener('pointerup', barUp);
      bar.addEventListener('pointercancel', barUp);
    }

    // 卡片区按住拖动（触屏交给原生滚动）
    var down = false, moved = false, startX = 0, startLeft = 0;
    grid.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'touch' || e.button !== 0) return;
      down = true; moved = false;
      startX = e.clientX; startLeft = grid.scrollLeft;
    });
    window.addEventListener('pointermove', function (e) {
      if (!down) return;
      var dx = e.clientX - startX;
      if (!moved && Math.abs(dx) > 6) {
        moved = true;
        grid.classList.add('is-dragging');
        grid.style.scrollSnapType = 'none';
      }
      if (moved) grid.scrollLeft = startLeft - dx;
    });
    window.addEventListener('pointerup', function () {
      if (!down) return;
      down = false;
      if (!moved) return;
      grid.classList.remove('is-dragging');
      settle();
      // 拖完这一次不要顺带触发卡片里的链接
      var kill = function (ev) { ev.preventDefault(); ev.stopPropagation(); };
      grid.addEventListener('click', kill, true);
      window.setTimeout(function () { grid.removeEventListener('click', kill, true); }, 0);
    });

    // 键盘左右翻页
    grid.addEventListener('keydown', function (e) {
      if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
      var step = grid.clientWidth * 0.8;
      grid.scrollBy({ left: e.key === 'ArrowRight' ? step : -step, behavior: 'smooth' });
      e.preventDefault();
    });

    // 入场
    if (!reduceMotion && 'IntersectionObserver' in window) {
      grid.classList.add('is-reveal');
      var items = [].slice.call(grid.children);
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          items.forEach(function (el) { el.classList.add('is-in'); });
          io.unobserve(entry.target);
        });
      }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
      io.observe(grid);
    }

    measure();
    if (window.requestAnimationFrame) window.requestAnimationFrame(measure);
    window.setTimeout(measure, 400);
    window.setTimeout(measure, 1200);
    window.addEventListener('resize', measure);
    window.addEventListener('load', measure);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(measure);
    if ('ResizeObserver' in window) {
      var ro = new ResizeObserver(measure);
      ro.observe(grid);
      ro.observe(root);
    }
  });
})();

/* ===== 17. 文章 · THE MAKEUP JOURNAL ===== */
(function () {
  var roots = document.querySelectorAll('[data-art]');
  if (!roots.length) return;

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var desktop = window.matchMedia ? window.matchMedia('(min-width: 1100px)') : null;

  Array.prototype.forEach.call(roots, function (root) {
    var thumbs = [].slice.call(root.querySelectorAll('[data-art-thumb]'));
    var layers = [].slice.call(root.querySelectorAll('[data-art-layer]'));
    var panels = [].slice.call(root.querySelectorAll('[data-art-panel]'));
    var status = root.querySelector('[data-art-status]');
    if (layers.length < 2) return;

    var index = 0;
    var timer = 0;
    var paused = false;
    var autoplay = root.getAttribute('data-autoplay') === 'true';
    var interval = Math.max(4, parseFloat(root.getAttribute('data-interval')) || 6) * 1000;

    function titleOf(k) {
      var p = panels[k];
      var t = p && p.querySelector('.wb-art__title');
      return t ? t.textContent.trim() : '';
    }

    function render() {
      layers.forEach(function (el, k) {
        el.setAttribute('data-state', k === index ? 'active' : (k < index ? 'prev' : 'next'));
      });
      panels.forEach(function (el, k) {
        el.setAttribute('data-state', k === index ? 'active' : (k < index ? 'prev' : 'next'));
        // 非当前面板不能进 tab 焦点，否则键盘 Tab 会掉进看不见的按钮里
        if (k === index) el.removeAttribute('inert');
        else el.setAttribute('inert', '');
      });
      thumbs.forEach(function (el, k) {
        el.classList.toggle('is-active', k === index);
        el.setAttribute('aria-current', k === index ? 'true' : 'false');
      });
      if (status) status.textContent = '第 ' + (index + 1) + ' 篇，共 ' + layers.length + ' 篇：' + titleOf(index);
    }

    function go(next, byUser) {
      var n = layers.length;
      var target = ((next % n) + n) % n;
      if (target === index) return;
      index = target;
      render();
      if (byUser) start(); // 手动切换后重新计时，不要刚点完就自动跳走
    }

    function start() {
      stop();
      if (!autoplay || reduceMotion) return;
      if (desktop && !desktop.matches) return;
      timer = window.setInterval(function () {
        if (paused || document.hidden) return;
        go(index + 1);
      }, interval);
    }

    function stop() {
      if (timer) { window.clearInterval(timer); timer = 0; }
    }

    thumbs.forEach(function (el, k) {
      el.addEventListener('click', function () { go(k, true); });
    });

    var thumbList = root.querySelector('[data-art-thumbs]');
    if (thumbList) {
      thumbList.addEventListener('keydown', function (e) {
        if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft' && e.key !== 'ArrowDown' && e.key !== 'ArrowUp') return;
        e.preventDefault();
        var step = (e.key === 'ArrowRight' || e.key === 'ArrowDown') ? 1 : -1;
        var next = (index + step + layers.length) % layers.length;
        go(next, true);
        var btn = thumbs[next];
        if (btn) btn.focus();
      });
    }

    // 鼠标悬停 / 键盘进入时暂停自动轮播，别在用户正读的时候跳走
    root.addEventListener('mouseenter', function () { paused = true; });
    root.addEventListener('mouseleave', function () { paused = false; });
    root.addEventListener('focusin', function () { paused = true; });
    root.addEventListener('focusout', function () { paused = false; });

    if (desktop && desktop.addEventListener) {
      desktop.addEventListener('change', function () { start(); });
    }

    render();
    start();

    // 入场：整组内容淡入上移
    if (!reduceMotion && 'IntersectionObserver' in window) {
      root.classList.add('is-reveal');
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          root.classList.add('is-in');
          io.unobserve(entry.target);
        });
      }, { threshold: 0.15 });
      io.observe(root);
    }
  });
})();

/* ===== 18. 文章目录 · IN THIS ARTICLE ===== */
(function () {
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function slug(text, i) {
    var s = text.toLowerCase().replace(/[^a-z0-9\s-]/g, '').trim().replace(/\s+/g, '-').slice(0, 60);
    return s ? 'article-' + s : 'article-section-' + i;
  }

  function build(nav) {
    if (nav.getAttribute('data-toc-ready') === 'true') return;
    var content = document.querySelector(nav.getAttribute('data-content'));
    var list = nav.querySelector('.wb-post__toc-list');
    if (!content || !list) return;

    var heads = [].filter.call(content.querySelectorAll('h2, h3'), function (h) {
      return h.textContent.trim() !== '';
    });
    // 正文没有小标题时整块目录不出现，别留一个空标题在左栏
    if (!heads.length) { nav.remove(); return; }

    nav.setAttribute('data-toc-ready', 'true');
    list.innerHTML = '';
    var links = [];

    function addLink(id, label, level) {
      var li = document.createElement('li');
      li.className = 'wb-post__toc-item wb-post__toc-item--' + level;
      var a = document.createElement('a');
      a.className = 'wb-post__toc-link';
      a.href = '#' + id;
      a.textContent = label;
      li.appendChild(a);
      list.appendChild(li);
      links.push(a);
    }

    var introLabel = nav.getAttribute('data-intro');
    if (introLabel) {
      if (!content.id) content.id = 'wb-post-body';
      addLink(content.id, introLabel, 'intro');
    }

    heads.forEach(function (h, i) {
      if (!h.id) {
        var base = slug(h.textContent, i + 1);
        var id = base;
        var n = 2;
        while (document.getElementById(id)) { id = base + '-' + n; n += 1; }
        h.id = id;
      }
      addLink(h.id, h.textContent.trim(), h.tagName.toLowerCase());
    });

    nav.hidden = false;

    var targets = links.map(function (a) {
      return document.getElementById(decodeURIComponent(a.hash.slice(1)));
    }).filter(Boolean);

    function setActive(target) {
      links.forEach(function (a) {
        var on = decodeURIComponent(a.hash.slice(1)) === target.id;
        a.classList.toggle('is-active', on);
        if (on) a.setAttribute('aria-current', 'location');
        else a.removeAttribute('aria-current');
      });
    }

    function sync() {
      // 判定线贴着吸顶栏下沿（140px），否则一进屏就把下一节点亮了
      var line = 140;
      var current = targets[0];
      targets.forEach(function (t) {
        if (t.getBoundingClientRect().top <= line) current = t;
      });
      if (current) setActive(current);
    }

    var ticking = false;
    function onScroll() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () { sync(); ticking = false; });
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });

    links.forEach(function (a) {
      a.addEventListener('click', function (e) {
        var target = document.getElementById(decodeURIComponent(a.hash.slice(1)));
        if (!target) return;
        e.preventDefault();
        // 吸顶导航会盖住标题，交由 CSS 的 scroll-margin-top 让位
        if (window.scrollY === 0 && a.classList.contains('is-active')) return;
        target.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
        if (!target.hasAttribute('tabindex')) target.setAttribute('tabindex', '-1');
        target.focus({ preventScroll: true });
        if (window.history.replaceState) window.history.replaceState(null, '', a.hash);
      });
    });

    sync();
  }

  function init() {
    [].forEach.call(document.querySelectorAll('[data-post-toc]'), build);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();

/* ===== 19. 联系页 · 入场动效 ===== */
(function () {
  var items = document.querySelectorAll('.wb-ct [data-ct-reveal]');
  if (!items.length) return;

  // 只有脚本跑起来才隐藏元素，JS 失败时内容照样可见
  document.documentElement.classList.add('ct-js');

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduce || !('IntersectionObserver' in window)) {
    [].forEach.call(items, function (el) { el.classList.add('is-visible'); });
    return;
  }

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      entry.target.classList.add('is-visible');
      io.unobserve(entry.target);
    });
  }, { threshold: 0.15 });

  [].forEach.call(items, function (el) { io.observe(el); });
})();
/* ===== 20. 关于页 · 入场 + 小图视差 ===== */
(function () {
  var root = document.querySelector('.wb-ab');
  if (!root) return;

  var panels = root.querySelectorAll('[data-ab-reveal]');
  var parallaxEl = root.querySelector('[data-ab-parallax]');
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var desktop = window.matchMedia && window.matchMedia('(min-width: 1200px)');
  var TRAVEL = 90;

  // 只有脚本跑起来才隐藏元素；否则内容永远可见
  if (panels.length && !reduceMotion && 'IntersectionObserver' in window) {
    document.documentElement.classList.add('ab-js');
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-in-view');
        io.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -10% 0px', threshold: 0.1 });
    [].forEach.call(panels, function (el) { io.observe(el); });
  }

  // 小图视差：只在 ≥1200 桌面、且用户没关动效时跑
  if (!parallaxEl || reduceMotion) return;

  var rafId = null;
  var onScroll = function () {
    if (rafId) return;
    rafId = window.requestAnimationFrame(function () {
      rafId = null;
      var rect = root.getBoundingClientRect();
      var vh = window.innerHeight || document.documentElement.clientHeight;
      var span = rect.height + vh;
      if (span <= 0) return;
      var p = (vh - rect.top) / span;
      p = p < 0 ? 0 : p > 1 ? 1 : p;
      var offset = (p - 0.5) * 2 * TRAVEL;
      parallaxEl.style.transform = 'translate3d(0, ' + offset.toFixed(2) + 'px, 0)';
    });
  };

  function enable() {
    if (desktop.matches) {
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll, { passive: true });
      onScroll();
    } else {
      parallaxEl.style.transform = '';
    }
  }

  enable();
  if (desktop.addEventListener) {
    desktop.addEventListener('change', function () {
      window.removeEventListener('scroll', onScroll);
      window.removeEventListener('resize', onScroll);
      enable();
    });
  }
})();
/* ===== 21. FAQ 手风琴（同时只开一条） ===== */
(function () {
  var groups = document.querySelectorAll('[data-faq]');
  if (!groups.length) return;

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function panelOf(btn) {
    return document.getElementById(btn.getAttribute('aria-controls'));
  }

  function open(item) {
    var btn = item.querySelector('.wb-faq__q');
    var panel = panelOf(btn);
    if (!btn || !panel) return;
    var inner = panel.firstElementChild;
    btn.setAttribute('aria-expanded', 'true');
    panel.style.height = inner ? inner.offsetHeight + 'px' : 'auto';
    if (!reduceMotion) {
      panel.addEventListener('transitionend', function done(e) {
        if (e.propertyName !== 'height') return;
        panel.removeEventListener('transitionend', done);
        // 展开后交回 auto，窗口变窄时内容不会被切
        if (btn.getAttribute('aria-expanded') === 'true') panel.style.height = 'auto';
      });
    }
  }

  function close(item) {
    var btn = item.querySelector('.wb-faq__q');
    var panel = panelOf(btn);
    if (!btn || !panel) return;
    btn.setAttribute('aria-expanded', 'false');
    // 从 auto 收回去要先把当前高度写死，否则没有过渡
    panel.style.height = panel.offsetHeight + 'px';
    void panel.offsetHeight;
    panel.style.height = '0px';
  }

  [].forEach.call(groups, function (group) {
    group.addEventListener('click', function (e) {
      var btn = e.target.closest('.wb-faq__q');
      if (!btn || !group.contains(btn)) return;
      var item = btn.closest('.wb-faq__item');
      var isOpen = btn.getAttribute('aria-expanded') === 'true';

      // 同一分组里同时只展开一条，和演示站一致
      [].forEach.call(group.querySelectorAll('.wb-faq__q[aria-expanded="true"]'), function (other) {
        if (other === btn) return;
        var otherItem = other.closest('.wb-faq__item');
        if (otherItem) close(otherItem);
      });

      if (isOpen) close(item);
      else open(item);
    });
  });

  window.addEventListener('resize', function () {
    [].forEach.call(document.querySelectorAll('.wb-faq__q[aria-expanded="true"]'), function (btn) {
      var panel = panelOf(btn);
      if (panel) panel.style.height = 'auto';
    });
  }, { passive: true });
})();

/* 22. 政策页标题校正
   Shopify 政策库把 SHIPPING_POLICY 的标题存成 "Shipping"，演示站显示的是
   "Shipping policy"。政策标题不在 ShopPolicyInput 里，API 改不了，这里做一次
   前端兜底；标题已经正确时不做任何改动。 */
(function () {
  if (location.pathname.indexOf('/policies/') === -1) return;
  var h1 = document.querySelector('.shopify-policy__title h1');
  if (!h1) return;
  var FIX = { Shipping: 'Shipping policy', Refund: 'Refund policy', Privacy: 'Privacy policy' };
  var cur = (h1.textContent || '').trim();
  if (FIX[cur]) h1.textContent = FIX[cur];
})();

/* 23. 分类页：吸顶偏移 / 筛选抽屉 / 排序提交 */
(function () {
  var root = document.querySelector('[data-coll]');
  if (!root) return;

  /* 吸顶筛选条贴在主导航下沿：顶栏高度会随公告条变化，直接量 */
  function setOffset() {
    var hd = document.querySelector('.wb-hd-sec') || document.querySelector('.wb-hd');
    var h = hd ? Math.round(hd.getBoundingClientRect().height) : 0;
    document.documentElement.style.setProperty('--coll-hdr', h + 'px');
  }
  setOffset();
  window.addEventListener('resize', setOffset, { passive: true });
  window.addEventListener('load', setOffset, { passive: true });

  var sel = root.querySelector('[data-coll-select]');
  if (sel && sel.form) {
    sel.addEventListener('change', function () {
      sel.form.submit();
    });
  }

  var drawer = root.querySelector('[data-coll-drawer]');
  var openBtn = root.querySelector('[data-coll-open]');
  if (!drawer || !openBtn) return;

  var lastFocus = null;

  function open() {
    lastFocus = document.activeElement;
    drawer.hidden = false;
    document.documentElement.classList.add('wb-coll-lock');
    var f = drawer.querySelector('.wb-coll__dclose');
    if (f) f.focus();
  }

  function close() {
    drawer.hidden = true;
    document.documentElement.classList.remove('wb-coll-lock');
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  openBtn.addEventListener('click', open);
  [].forEach.call(drawer.querySelectorAll('[data-coll-close]'), function (b) {
    b.addEventListener('click', close);
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !drawer.hidden) close();
  });
})();

/* 24. 分类页：单款商品直接在列表加购（多款商品仍走快速查看） */
(function () {
  var root = document.querySelector('[data-coll]');
  if (!root) return;

  root.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-coll-add]');
    if (!btn || btn.classList.contains('is-busy')) return;
    e.preventDefault();
    var id = btn.getAttribute('data-coll-add');
    if (!id) return;

    btn.classList.add('is-busy');

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: Number(id), quantity: 1 })
    })
      .then(function (r) { if (!r.ok) throw new Error('add failed'); return fetch('/cart.js'); })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var n = document.querySelector('[data-cart-count]');
        if (n) { n.textContent = cart.item_count; n.hidden = cart.item_count === 0; }
        btn.classList.remove('is-busy');
        btn.classList.add('is-added');
        if (window.WB && window.WB.cart) window.WB.cart.open();
        setTimeout(function () { btn.classList.remove('is-added'); }, 1400);
      })
      .catch(function () {
        btn.classList.remove('is-busy');
        window.location.href = btn.getAttribute('data-coll-href') || btn.getAttribute('href') || '/cart';
      });
  });
})();

/* 25. 商品卡：鼠标悬停某个 SKU 缩略图 → 大图切成该 SKU 的图（双缓冲，换图不闪） */
(function () {
  if (!window.matchMedia || !window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;

  var curArt = null;
  var state = new WeakMap(); // art -> { idx: 当前在上层的层号, src: 当前显示的图, token: 作废令牌 }

  function show(dot) {
    var art = dot.closest('.wb-item') || dot.closest('.wb-rcard');
    if (!art) return;
    var layers = art.querySelectorAll('.wb-item__img--var, .wb-rcard__img--var');
    if (layers.length < 2) return;
    var src = dot.getAttribute('data-wb-img');
    if (!src) return;

    art.classList.add('is-var');
    curArt = art;

    var st = state.get(art) || { idx: 0, src: '', token: 0 };
    if (st.src === src) return; // 已经显示这张，不用重复解码
    var top = layers[st.idx];
    var next = layers[1 - st.idx];
    var token = ++st.token;
    state.set(art, st);

    /* 要点：新图解码完成之前不碰上层，旧色号图继续顶着，
       所以中间不会出现空档去露出底下的主图 / 悬停图 */
    function commit() {
      if (token !== st.token) return; // 期间又划到别的色卡，这次作废
      next.classList.add('is-on');
      top.classList.remove('is-on');
      st.idx = 1 - st.idx;
      st.src = src;
    }

    if (next.getAttribute('src') !== src) next.setAttribute('src', src);

    if (next.complete && next.naturalWidth > 0) {
      commit();
    } else if (next.decode) {
      next.decode().then(commit, commit);
    } else {
      next.onload = commit;
      next.onerror = commit;
    }
  }

  function hide() {
    if (!curArt) return;
    curArt.classList.remove('is-var');
    curArt = null;
  }

  document.addEventListener('mouseover', function (e) {
    var dot = e.target.closest && e.target.closest('.wb-item__dot');
    if (!dot) return;
    show(dot);
  });

  document.addEventListener('mouseout', function (e) {
    var dot = e.target.closest && e.target.closest('.wb-item__dot');
    if (!dot) return;
    var to = e.relatedTarget;
    var art = dot.closest('.wb-item') || dot.closest('.wb-rcard');
    /* 移到同一张卡的另一个缩略图时不动，交给 mouseover 接着换 */
    if (to && art && art.contains(to)) return;
    hide();
  });
})();

/* 26. 分类列表页：分页 + 卡片滚动入场
   分页做在前端：paginate collections 会把 collections 截成当前页，导致自定义顺序
   的后半段取不到，所以模板一次渲染全部卡片，这里按 ?page= 显示对应的一组。 */
(function () {
  var grid = document.querySelector('.wb-cls__grid');
  if (!grid) return;

  var cards = Array.prototype.slice.call(grid.querySelectorAll('.wb-cls__card'));
  if (!cards.length) return;

  /* —— 分页 —— */
  var pager = document.querySelector('[data-cls-pager]');
  var per = Number((pager && pager.getAttribute('data-per')) || 16);
  var pages = pager ? Math.ceil(cards.length / per) : 1;

  function parsePage() {
    var m = location.search.match(/[?&]page=(\d+)/);
    var n = m ? Number(m[1]) : 1;
    if (!n || n < 1) n = 1;
    if (n > pages) n = pages;
    return n;
  }

  function paint(n) {
    var from = (n - 1) * per;
    for (var i = 0; i < cards.length; i++) {
      var show = i >= from && i < from + per;
      if (show) {
        cards[i].removeAttribute('hidden');
        cards[i].classList.add('is-in');
      } else {
        cards[i].setAttribute('hidden', '');
      }
    }
    if (!pager) return;
    var ul = pager.querySelector('ul');
    var html = '';
    if (n > 1) html += '<li><a class="wb-cls__parrow" href="?page=' + (n - 1) + '" data-pg="' + (n - 1) + '" aria-label="Previous">\u2039</a></li>';
    for (var p = 1; p <= pages; p++) {
      html += '<li><a href="?page=' + p + '" data-pg="' + p + '"' + (p === n ? ' class="is-current" aria-current="page"' : '') + '>' + p + '</a></li>';
    }
    if (n < pages) html += '<li><a class="wb-cls__parrow" href="?page=' + (n + 1) + '" data-pg="' + (n + 1) + '" aria-label="Next">\u203a</a></li>';
    ul.innerHTML = html;
  }

  if (pager && pages > 1) {
    pager.removeAttribute('hidden');
    pager.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('a[data-pg]');
      if (!a) return;
      e.preventDefault();
      var n = Number(a.getAttribute('data-pg'));
      paint(n);
      if (history.replaceState) history.replaceState(null, '', '?page=' + n);
      var top = grid.getBoundingClientRect().top + window.pageYOffset - 120;
      window.scrollTo({ top: top, behavior: 'smooth' });
    });
  }
  paint(parsePage());

  /* —— 入场动画 —— */
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var i;
  if (!('IntersectionObserver' in window) || reduce) {
    for (i = 0; i < cards.length; i++) cards[i].classList.add('is-in');
    return;
  }

  var io = new IntersectionObserver(function (entries) {
    for (var k = 0; k < entries.length; k++) {
      var en = entries[k];
      if (!en.isIntersecting) continue;
      var idx = Number(en.target.getAttribute('data-i') || 0) % 4;
      (function (el, d) {
        setTimeout(function () { el.classList.add('is-in'); }, d);
      })(en.target, idx * 60);
      io.unobserve(en.target);
    }
  }, { rootMargin: '0px 0px -40px 0px', threshold: 0.05 });

  for (i = 0; i < cards.length; i++) io.observe(cards[i]);
})();

/* 27. 商品详情页：描述展开 / 数量 / 变体切换 / 加购 / 前后对比滑块 */
(function () {
  var root = document.querySelector('[data-wb-pdp]');
  if (!root) return;

  /* ---- 吸顶偏移：右栏贴住顶栏下沿，高度随公告条变化实时量 ---- */
  (function () {
    var hd = document.querySelector('.wb-hd-sec') || document.querySelector('.wb-hd');
    var last = -1;
    function setHdr() {
      var h = hd ? Math.round(hd.getBoundingClientRect().height) : 0;
      if (h === last) return;
      last = h;
      document.documentElement.style.setProperty('--pdp-hdr', h + 'px');
    }
    setHdr();
    window.addEventListener('resize', setHdr, { passive: true });
    window.addEventListener('load', setHdr, { passive: true });
    var raf = false;
    window.addEventListener('scroll', function () {
      if (raf) return;
      raf = true;
      requestAnimationFrame(function () { raf = false; setHdr(); });
    }, { passive: true });
  })();

  /* ---- 手风琴：同时只允许展开一个 ---- */
  (function () {
    var accs = root.querySelectorAll('.wb-pdp__acitem');
    if (accs.length < 2) return;
    Array.prototype.forEach.call(accs, function (d) {
      d.addEventListener('toggle', function () {
        if (!d.open) return;
        Array.prototype.forEach.call(accs, function (o) {
          if (o !== d && o.open) o.open = false;
        });
      });
    });
  })();

  var money = (function () {
    var cur = root.getAttribute('data-currency') || 'USD';
    try {
      var nf = new Intl.NumberFormat('en-US', { style: 'currency', currency: cur });
      return function (cents) { return nf.format(Number(cents) / 100); };
    } catch (e) {
      return function (cents) { return '$' + (Number(cents) / 100).toFixed(2); };
    }
  })();

  /* ---- 描述：自动判断是否被截断，展开/收起 ---- */
  var desc = root.querySelector('[data-wb-desc]');
  var more = root.querySelector('[data-wb-more]');
  if (desc && more) {
    var syncMore = function () {
      if (desc.classList.contains('is-open')) return;
      more.hidden = desc.scrollHeight <= desc.clientHeight + 2;
    };
    syncMore();
    window.addEventListener('resize', syncMore);
    more.addEventListener('click', function () {
      var open = desc.classList.toggle('is-open');
      more.textContent = open ? 'Read Less' : 'Read More';
      if (!open) syncMore();
    });
  }

  /* ---- 数量 ---- */
  var qty = root.querySelector('[data-wb-qty]');
  var idInput = root.querySelector('[data-wb-vid]');
  var atc = root.querySelector('[data-wb-atc]');
  var atcTxt = atc && atc.querySelector('.wb-pdp__atc-txt');

  root.querySelectorAll('[data-wb-q]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      if (!qty) return;
      var step = Number(btn.getAttribute('data-wb-q'));
      var next = Math.max(1, (parseInt(qty.value, 10) || 1) + step);
      qty.value = next;
    });
  });
  if (qty) {
    qty.addEventListener('change', function () {
      var v = parseInt(qty.value, 10);
      qty.value = isNaN(v) || v < 1 ? 1 : v;
    });
  }

  /* ---- 变体 ---- */
  var vwrap = root.querySelector('[data-wb-variants]');
  var variants = [];
  try { variants = vwrap ? JSON.parse(vwrap.textContent) : []; } catch (e) { variants = []; }

  var labels = [].slice.call(root.querySelectorAll('.wb-pdp__val'));

  function selectedMap() {
    var m = {};
    labels.forEach(function (l) {
      if (l.classList.contains('is-on')) m[l.getAttribute('data-opt-i')] = l.getAttribute('data-value');
    });
    return m;
  }

  function findVariant(map) {
    for (var i = 0; i < variants.length; i++) {
      var v = variants[i], ok = true;
      for (var k in map) {
        if (String(v.options[Number(k)]) !== String(map[k])) { ok = false; break; }
      }
      if (ok) return v;
    }
    return null;
  }

  function paint(v) {
    if (!v) return;
    if (idInput) idInput.value = v.id;

    var now = root.querySelector('.wb-pdp__price-now');
    if (now) now.textContent = money(v.price);

    var was = root.querySelector('.wb-pdp__price-was');
    if (was) {
      if (v.compare_at_price && v.compare_at_price > v.price) {
        was.textContent = money(v.compare_at_price);
        was.hidden = false;
      } else {
        was.hidden = true;
      }
    }

    var row = root.querySelector('.wb-pdp__stock-row');
    var num = root.querySelector('.wb-pdp__stock-num');
    var txt = root.querySelector('.wb-pdp__stock-txt');
    if (row) {
      row.classList.toggle('is-in', !!v.available);
      row.classList.toggle('is-out', !v.available);
    }
    if (txt) txt.textContent = v.available ? 'In stock' : 'Out of stock';
    if (num) {
      var tracked = v.inventory_management != null && v.inventory_management !== '';
      if (v.available && tracked && v.inventory_quantity > 0) {
        num.textContent = '(' + v.inventory_quantity + ' items in Stock)';
        num.hidden = false;
      } else {
        num.hidden = true;
      }
    }

    if (atc) {
      atc.disabled = !v.available;
      if (atcTxt) atcTxt.textContent = v.available ? 'ADD TO CART' : 'SOLD OUT';
    }

    /* 主图跟随：把变体图与 hero 格「互换」——hero 显示当前色号图，原 hero 图退回它原来的格子
       与演示站行为一致（不是覆盖，所以不会重复也不会丢图） */
    if (v.featured_image && v.featured_image.src) {
      var cells = root.querySelectorAll('.wb-pdp__cell');
      var hero = root.querySelector('.wb-pdp__cell.is-hero');
      var wantId = v.featured_image.id ? String(v.featured_image.id) : '';
      var wantKey = imgKey(v.featured_image.src);
      var hit = -1;

      for (var i = 0; i < cells.length; i++) {
        var mid = cells[i].getAttribute('data-media-id');
        if (wantId && mid && String(mid) === wantId) { hit = i; break; }
      }
      if (hit < 0 && wantKey) {
        for (var j = 0; j < cells.length; j++) {
          var jm = cells[j].querySelector('img');
          if (jm && imgKey(jm.currentSrc || jm.src) === wantKey) { hit = j; break; }
        }
      }

      if (hit > -1 && hero && cells[hit] !== hero) {
        swapImg(hero.querySelector('img'), cells[hit].querySelector('img'));
        /* media id 跟着图一起走，否则下次匹配还指回旧格子，会来回换 */
        var ma = hero.getAttribute('data-media-id'), mb = cells[hit].getAttribute('data-media-id');
        if (mb === null) hero.removeAttribute('data-media-id'); else hero.setAttribute('data-media-id', mb);
        if (ma === null) cells[hit].removeAttribute('data-media-id'); else cells[hit].setAttribute('data-media-id', ma);

        var g = root.querySelector('.wb-pdp__grid');
        if (g && window.matchMedia('(max-width: 899px)').matches && g.scrollLeft > 4) {
          g.scrollTo({ left: 0, behavior: 'smooth' });
        }
      }
    }
  }

  /* 变体图与网格图的对应：优先 media id；回退按文件名（去掉 CDN 的 _1200x / _crop_center / @2x 后缀） */
  function imgKey(u) {
    return String(u || '')
      .split('/').pop().split('?')[0]
      .replace(/\.(png|jpe?g|webp|gif|avif)$/i, '')
      .replace(/_crop_[a-z]+$/i, '')
      .replace(/@\d+x$/i, '')
      .replace(/_\d+x\d*$/i, '');
  }

  /* 只互换「画面」相关的属性，loading/fetchpriority 原地不动 */
  function swapImg(a, b) {
    if (!a || !b) return;
    ['src', 'srcset', 'sizes', 'width', 'height', 'alt'].forEach(function (k) {
      var va = a.getAttribute(k), vb = b.getAttribute(k);
      if (vb === null) a.removeAttribute(k); else a.setAttribute(k, vb);
      if (va === null) b.removeAttribute(k); else b.setAttribute(k, va);
    });
  }

  labels.forEach(function (l) {
    l.addEventListener('click', function (e) {
      /* 点 label 会连带触发内部 radio 的 click 再冒泡回来一次，忽略后者，避免一次点击跑两遍 */
      if (e.target && e.target.tagName === 'INPUT') return;
      if (l.classList.contains('is-off')) { e.preventDefault(); return; }
      var group = l.getAttribute('data-opt-i');
      labels.forEach(function (o) {
        if (o.getAttribute('data-opt-i') === group) o.classList.remove('is-on');
      });
      l.classList.add('is-on');
      var cur = root.querySelector('[data-wb-opt-cur="' + group + '"]');
      if (cur) cur.textContent = l.getAttribute('data-value');
      var v = findVariant(selectedMap());
      if (v) paint(v);
    });
  });

  /* ---- 加购 ---- */
  var form = root.querySelector('#wb-pdp-form');
  if (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (!atc || atc.disabled) return;
      var id = idInput ? Number(idInput.value) : 0;
      if (!id) return;
      var n = parseInt(qty && qty.value, 10) || 1;
      var label = atcTxt ? atcTxt.textContent : '';
      atc.classList.add('is-loading');
      if (atcTxt) atcTxt.textContent = 'ADDING…';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: id, quantity: n }] })
      })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
        .then(function (res) {
          if (!res.ok) throw new Error(res.j && res.j.description ? res.j.description : 'add failed');
          return fetch('/cart.js').then(function (r) { return r.json(); });
        })
        .then(function (cart) {
          document.querySelectorAll('[data-cart-count]').forEach(function (el) {
            el.textContent = cart.item_count;
          });
          if (atcTxt) atcTxt.textContent = 'ADDED ✓';
          if (window.WB && window.WB.cart) window.WB.cart.open();
          setTimeout(function () {
            if (atcTxt) atcTxt.textContent = label;
            atc.classList.remove('is-loading');
          }, 1600);
        })
        .catch(function (err) {
          if (atcTxt) atcTxt.textContent = 'TRY AGAIN';
          setTimeout(function () {
            if (atcTxt) atcTxt.textContent = label;
            atc.classList.remove('is-loading');
          }, 1600);
          if (window.console) console.warn('[wb-pdp] 加购失败：', err.message);
        });
    });
  }

  /* ---- 移动端圆点指示器 ---- */
  var grid = root.querySelector('.wb-pdp__grid');
  var dotsWrap = root.querySelector('[data-wb-dots]');
  if (grid && dotsWrap) {
    var cells = grid.querySelectorAll('.wb-pdp__cell');
    var dots = [];
    for (var i = 0; i < cells.length; i++) {
      var d = document.createElement('i');
      dotsWrap.appendChild(d);
      dots.push(d);
    }
    if (dots[0]) dots[0].classList.add('is-on');
    var tick;
    grid.addEventListener('scroll', function () {
      clearTimeout(tick);
      tick = setTimeout(function () {
        var w = grid.clientWidth || 1;
        var idx = Math.round(grid.scrollLeft / w);
        dots.forEach(function (el, k) { el.classList.toggle('is-on', k === idx); });
      }, 80);
    }, { passive: true });
  }
})();

/* 28. 商品页 before/after 对比滑块（与首页共用 --ba-pos，裁剪/竖线/标签淡出都由 CSS 算） */
(function () {
  document.querySelectorAll('[data-wb-ba]').forEach(function (stage) {
    var r = stage.querySelector('[data-wb-ba-range]');
    if (!r) return;
    var upd = function () {
      var v = Number(r.value) || 0;
      stage.style.setProperty('--ba-pos', v + '%');
      stage.style.setProperty('--ba-p', (v / 100).toFixed(4));
    };
    r.addEventListener('input', upd);
    r.addEventListener('change', upd);
    upd();
  });
})();

/* 29. 商品页 · YOU MAY ALSO LIKE（横向轮播 + 快捷加购）
   箭头：一次滚一张卡；到最左/最右自动淡出（首屏左侧箭头不可见，点过右侧才出现） */
(function () {
  document.querySelectorAll('[data-wb-rec]').forEach(function (root) {
    var vp = root.querySelector('[data-wb-rec-track]');
    if (!vp) return;
    var stage = vp.parentNode;
    var prev = root.querySelector('[data-wb-rec-prev]');
    var next = root.querySelector('[data-wb-rec-next]');
    var items = vp.querySelectorAll('.wb-rec__item');

    /* 箭头垂直居中于卡片图片（方图宽 = 卡宽 - 2 * 5px 内边距） */
    function measure() {
      if (!items.length) return;
      var w = items[0].getBoundingClientRect().width;
      stage.style.setProperty('--rec-media-h', Math.max(0, Math.round((w - 10) * 100) / 100) + 'px');
    }

    function stepSize() {
      if (items.length > 1) {
        var a = items[0].getBoundingClientRect();
        var b = items[1].getBoundingClientRect();
        var d = b.left - a.left;
        if (d > 1) return d;
      }
      return items.length ? items[0].getBoundingClientRect().width : 0;
    }

    function sync() {
      var max = vp.scrollWidth - vp.clientWidth;
      var x = vp.scrollLeft;
      var staticMode = max <= 2;
      stage.classList.toggle('is-static', staticMode);
      if (prev) {
        var p0 = x <= 2;
        prev.disabled = p0 || staticMode;
        prev.setAttribute('aria-disabled', p0 || staticMode ? 'true' : 'false');
      }
      if (next) {
        var n0 = x >= max - 2;
        next.disabled = n0 || staticMode;
        next.setAttribute('aria-disabled', n0 || staticMode ? 'true' : 'false');
      }
    }

    function go(dir) {
      var target = vp.scrollLeft + dir * stepSize();
      var max = vp.scrollWidth - vp.clientWidth;
      if (target < 0) target = 0;
      if (target > max) target = max;
      vp.scrollTo({ left: target, behavior: 'smooth' });
    }

    if (prev) prev.addEventListener('click', function () { go(-1); });
    if (next) next.addEventListener('click', function () { go(1); });

    var raf = 0;
    vp.addEventListener('scroll', function () {
      if (raf) return;
      raf = requestAnimationFrame(function () { raf = 0; sync(); });
    }, { passive: true });

    var rt = 0;
    window.addEventListener('resize', function () {
      clearTimeout(rt);
      rt = setTimeout(function () { measure(); sync(); }, 120);
    });

    if (window.ResizeObserver) {
      var lastW = 0;
      new ResizeObserver(function () {
        var w = Math.round(stage.getBoundingClientRect().width);
        if (w === lastW) return;
        lastW = w;
        measure();
        sync();
      }).observe(stage);
    }

    measure();
    sync();

    /* ---- 快捷加购 ---- */
    root.addEventListener('click', function (e) {
      var btn = e.target.closest ? e.target.closest('[data-wb-rec-atc]') : null;
      if (!btn || btn.disabled) return;
      var id = Number(btn.getAttribute('data-vid'));
      if (!id) return;
      e.preventDefault();
      if (btn.classList.contains('is-busy')) return;
      btn.classList.add('is-busy');

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
      })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
        .then(function (res) {
          if (!res.ok) throw new Error(res.j && res.j.description ? res.j.description : 'add failed');
          return fetch('/cart.js').then(function (r) { return r.json(); });
        })
        .then(function (cart) {
          document.querySelectorAll('[data-cart-count]').forEach(function (el) {
            el.textContent = cart.item_count;
          });
          btn.classList.remove('is-busy');
          btn.classList.add('is-done');
          if (window.WB && window.WB.cart) window.WB.cart.open();
          setTimeout(function () { btn.classList.remove('is-done'); }, 1400);
        })
        .catch(function (err) {
          btn.classList.remove('is-busy');
          if (window.console) console.warn('[wb-rec] 加购失败：', err.message);
        });
    });
  });
})();

/* 30. 购物车抽屉（全站）
   数据源：snippet 里的 {{ cart | json }} 初始值 + /cart.js 实时值
   内容全部由 JS 渲染，避免服务端 / 客户端两套模板走偏 */
(function () {
  var root = document.querySelector('[data-wb-cd]');
  if (!root) return;

  var panel   = root.querySelector('.wb-cd__panel');
  var bodyEl  = root.querySelector('[data-wb-cd-body]');
  var footEl  = root.querySelector('[data-wb-cd-foot]');
  var shipEl  = root.querySelector('[data-wb-cd-ship]');
  var countEl = root.querySelector('[data-wb-cd-count]');
  var noteEl  = root.querySelector('[data-wb-cd-note]');

  var THRESHOLD = Math.round((parseFloat(root.getAttribute('data-threshold')) || 0) * 100);
  var MONEY = root.getAttribute('data-money-format') || '${{amount}}';
  var CART_URL = root.getAttribute('data-cart-url') || '/cart';

  var state = null;
  var busyTimer = 0;
  var noteTimer = 0;

  /* ---------- 工具 ---------- */
  function fmt(cents) {
    cents = Number(cents) || 0;
    var v = cents / 100;
    var dec = v.toFixed(2);
    var nod = String(Math.round(v));
    var map = {
      amount: dec,
      amount_no_decimals: nod,
      amount_with_comma_separator: dec.replace('.', ','),
      amount_no_decimals_with_comma_separator: nod
    };
    return MONEY.replace(/\{\{\s*(amount(?:_no_decimals)?(?:_with_comma_separator)?)\s*\}\}/g, function (m, k) {
      return map[k] != null ? map[k] : m;
    });
  }

  function esc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  function imgUrl(url, w) {
    if (!url) return '';
    return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + (w || 160);
  }

  function opts(item) {
    var arr = item.options_with_values || [];
    var out = [];
    arr.forEach(function (o) {
      if (!o || !o.value) return;
      if (/^(title|default title)$/i.test(o.value)) return;
      if (o.name && /^(title)$/i.test(o.name)) return;
      out.push(o.name ? esc(o.name) + ': ' + esc(o.value) : esc(o.value));
    });
    return out.join(' · ');
  }

  var ICON_UP = '<svg viewBox="0 0 11 7" width="11" height="7" fill="none" aria-hidden="true"><path d="M1 6l4.5-4.5L10 6" stroke="currentColor" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  var ICON_DOWN = '<svg viewBox="0 0 11 7" width="11" height="7" fill="none" aria-hidden="true"><path d="M1 1l4.5 4.5L10 1" stroke="currentColor" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  /* ---------- 渲染 ---------- */
  function renderRows(cart) {
    if (!cart.items || !cart.items.length) {
      bodyEl.innerHTML = '<div class="wb-cd__empty"><p>Your cart is empty.</p>' +
        '<button type="button" class="wb-cd__checkout" data-wb-cd-close style="max-width:220px;margin:0 auto;">CONTINUE SHOPPING</button></div>';
      return;
    }
    var html = cart.items.map(function (it) {
      var o = opts(it);
      var price = fmt(it.final_price);
      var was = (it.original_price && it.original_price > it.final_price) ? '<s style="opacity:.55">' + fmt(it.original_price) + '</s>' : '';
      var unit = it.quantity > 1 ? '<span style="opacity:.7">× ' + it.quantity + '</span>' : '';
      return '<li class="wb-cdi" data-key="' + esc(it.key) + '">' +
        '<a class="wb-cdi__media" href="' + esc(it.url) + '" tabindex="-1" aria-hidden="true">' +
          (it.image ? '<img src="' + esc(imgUrl(it.image, 160)) + '" alt="' + esc(it.product_title || it.title) + '" loading="eager" decoding="async" width="80" height="80">' : '') +
        '</a>' +
        '<div class="wb-cdi__info">' +
          '<p class="wb-cdi__title"><a href="' + esc(it.url) + '">' + esc(it.product_title || it.title) + '</a></p>' +
          '<div class="wb-cdi__price"><span>' + price + '</span>' + was + ' ' + unit + '</div>' +
          (o ? '<div class="wb-cdi__opt">' + o + '</div>' : '') +
          '<button type="button" class="wb-cdi__rm" data-wb-cd-rm>Remove</button>' +
        '</div>' +
        '<div class="wb-cdi__qty">' +
          '<button type="button" class="wb-cdi__qbtn" data-wb-cd-inc aria-label="Increase quantity">' + ICON_UP + '</button>' +
          '<input class="wb-cdi__qinput" type="text" inputmode="numeric" value="' + it.quantity + '" data-wb-cd-qty aria-label="Quantity">' +
          '<button type="button" class="wb-cdi__qbtn" data-wb-cd-dec aria-label="Decrease quantity"' + (it.quantity <= 1 ? ' disabled' : '') + '>' + ICON_DOWN + '</button>' +
        '</div>' +
      '</li>';
    }).join('');
    bodyEl.innerHTML = '<ul class="wb-cd__list">' + html + '</ul>';
  }

  function renderShip(cart) {
    var total = Number(cart.total_price) || 0;
    if (!THRESHOLD) { shipEl.innerHTML = ''; return; }
    var left = THRESHOLD - total;
    var pct = Math.max(0, Math.min(100, (total / THRESHOLD) * 100));
    var msg = left > 0
      ? 'SPEND <strong>' + fmt(left) + '</strong> MORE FOR FREE SHIPPING!'
      : "YOU'VE QUALIFIED FOR FREE SHIPPING!";
    shipEl.innerHTML =
      '<p class="wb-cd__shipmsg">' + msg + '</p>' +
      '<div class="wb-cd__shiptrack"><div class="wb-cd__shipfill" style="width:' + pct.toFixed(2) + '%"></div></div>';
  }

  function renderFoot(cart) {
    if (!cart.items || !cart.items.length) { footEl.hidden = true; footEl.innerHTML = ''; return; }
    footEl.hidden = false;
    footEl.innerHTML =
      '<div class="wb-cd__sum">' +
        '<div class="wb-cd__sumrow">' +
          '<h3 class="wb-cd__sumlabel">Total</h3>' +
          '<p class="wb-cd__sumprice">' + fmt(cart.total_price) + '</p>' +
        '</div>' +
        '<p class="wb-cd__tax">Taxes included. Discounts and <a href="/policies/shipping-policy">shipping</a> calculated at checkout.</p>' +
      '</div>' +
      '<form action="' + esc(CART_URL) + '" method="post" style="margin:0">' +
        '<button class="wb-cd__checkout" type="submit" name="checkout">CHECKOUT</button>' +
      '</form>' +
      '<div class="wb-cd__links">' +
        '<button type="button" class="wb-cd__link" data-wb-cd-close>CONTINUE SHOPPING</button>' +
        '<span class="wb-cd__sep" aria-hidden="true"></span>' +
        '<a class="wb-cd__link" href="' + esc(CART_URL) + '">VIEW CART</a>' +
      '</div>';
  }

  function render(cart) {
    if (!cart) return;
    state = cart;
    countEl.textContent = cart.item_count || 0;
    renderRows(cart);
    renderShip(cart);
    renderFoot(cart);
    if (noteEl && document.activeElement !== noteEl) noteEl.value = cart.note || '';
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = cart.item_count;
      if (el.hasAttribute('hidden') || el.classList.contains('is-hidden')) {
        if (cart.item_count > 0) el.removeAttribute('hidden');
        else el.setAttribute('hidden', '');
      }
    });
  }

  /* ---------- 网络 ---------- */
  function getCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); });
  }

  function refresh() {
    return getCart().then(render).catch(function () {});
  }

  function changeQty(key, qty) {
    var row = bodyEl.querySelector('[data-key="' + (window.CSS && CSS.escape ? CSS.escape(key) : key) + '"]');
    if (row) row.classList.add('is-busy');
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (cart && cart.status) return getCart().then(render); // 422 等：退回真实状态
        render(cart);
      })
      .catch(function () { return refresh(); });
  }

  /* ---------- 开合 ---------- */
  function open() {
    if (root.classList.contains('is-open')) { refresh(); return; }
    root.classList.add('is-open');
    root.setAttribute('aria-hidden', 'false');
    document.body.classList.add('wb-cd-lock');
    refresh();
    setTimeout(function () { try { panel.focus({ preventScroll: true }); } catch (e) { panel.focus(); } }, 120);
  }

  function close() {
    if (!root.classList.contains('is-open')) return;
    root.classList.remove('is-open');
    document.body.classList.remove('wb-cd-lock');
    closeTool();
    setTimeout(function () { root.setAttribute('aria-hidden', 'true'); }, 520);
  }

  /* ---------- 工具面板 ---------- */
  var toolEls = root.querySelectorAll('[data-wb-cd-tp]');
  function closeTool() {
    toolEls.forEach(function (p) { p.hidden = true; });
    root.querySelectorAll('[data-wb-cd-tool]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
  }
  function openTool(name) {
    var target = null;
    toolEls.forEach(function (p) {
      var on = p.getAttribute('data-wb-cd-tp') === name;
      p.hidden = !on;
      if (on) target = p;
    });
    root.querySelectorAll('[data-wb-cd-tool]').forEach(function (b) {
      b.setAttribute('aria-expanded', b.getAttribute('data-wb-cd-tool') === name ? 'true' : 'false');
    });
    if (target) {
      var f = target.querySelector('textarea, input');
      if (f) setTimeout(function () { f.focus(); }, 60);
    }
  }

  /* ---------- 事件 ---------- */
  root.addEventListener('click', function (e) {
    var t = e.target;

    if (t.closest('[data-wb-cd-close], .wb-cd__scrim')) { e.preventDefault(); close(); return; }

    var tool = t.closest('[data-wb-cd-tool]');
    if (tool) {
      var n = tool.getAttribute('data-wb-cd-tool');
      var op = tool.getAttribute('aria-expanded') === 'true';
      if (op) closeTool(); else openTool(n);
      return;
    }
    if (t.closest('[data-wb-cd-tpclose]')) { closeTool(); return; }

    var row = t.closest('.wb-cdi');
    if (row) {
      var key = row.getAttribute('data-key');
      var input = row.querySelector('[data-wb-cd-qty]');
      var q = parseInt(input && input.value, 10) || 1;

      if (t.closest('[data-wb-cd-inc]')) { changeQty(key, q + 1); return; }
      if (t.closest('[data-wb-cd-dec]')) { if (q > 1) changeQty(key, q - 1); return; }
      if (t.closest('[data-wb-cd-rm]')) {
        if (row) row.classList.add('is-busy');
        changeQty(key, 0); return;
      }
    }
  });

  root.addEventListener('change', function (e) {
    var inp = e.target.closest('[data-wb-cd-qty]');
    if (!inp) return;
    var row = inp.closest('.wb-cdi');
    var q = parseInt(inp.value, 10);
    if (isNaN(q) || q < 0) q = 1;
    if (q === 0) { changeQty(row.getAttribute('data-key'), 0); return; }
    changeQty(row.getAttribute('data-key'), q);
  });

  root.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { close(); return; }
    var inp = e.target.closest('[data-wb-cd-qty]');
    if (inp && e.key === 'Enter') { e.preventDefault(); inp.blur(); }
  });

  /* 头部 / 任意位置的购物车入口 */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-wb-cd-open]');
    if (!btn) return;
    e.preventDefault();
    open();
  });

  /* 订单备注：失焦或停止输入 800ms 自动保存（演示站浮层内无保存按钮） */
  if (noteEl) {
    var noteTimer = null, noteLast = noteEl.value;
    var saveNote = function () {
      var v = noteEl.value;
      if (v === noteLast) return;
      noteLast = v;
      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ note: v })
      })
        .then(function (r) { return r.json(); })
        .then(function (cart) { if (cart) { state = cart; noteLast = cart.note || ''; } })
        .catch(function () {});
    };
    noteEl.addEventListener('blur', function () { clearTimeout(noteTimer); saveNote(); });
    noteEl.addEventListener('input', function () {
      clearTimeout(noteTimer);
      noteTimer = setTimeout(saveNote, 800);
    });
  }

  /* 优惠码 */
  var disForm = root.querySelector('[data-wb-cd-dis]');
  if (disForm) {
    disForm.addEventListener('submit', function (e) {
      e.preventDefault();
      var code = (disForm.querySelector('input[name="discount"]') || {}).value || '';
      code = code.trim();
      if (!code) return;
      window.location.href = '/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(CART_URL);
    });
  }

  /* ---------- 初始化 ---------- */
  var initEl = document.querySelector('[data-wb-cd-init]');
  if (initEl) {
    try { render(JSON.parse(initEl.textContent)); } catch (e) {}
  }
  // 不在初始化时请求 /cart.js：服务端已给初始数据，打开抽屉时再刷新，省一个全站请求

  window.WB = window.WB || {};
  window.WB.cart = {
    open: open,
    close: close,
    refresh: refresh
  };
})();

/* 31. 独立购物车页 /cart（AJAX 改数量，不刷新页面） */
(function () {
  var form = document.querySelector('[data-wb-cart-form]');
  if (!form) return;

  var initEl = document.querySelector('[data-wb-cart-init]');
  var cfg = { threshold: 7500, money: '${{amount}}' };
  if (initEl) { try { cfg = JSON.parse(initEl.textContent) || cfg; } catch (e) {} }

  var TH = Number(cfg.threshold) || 0;
  var MONEY = cfg.money || '${{amount}}';

  function fmt(cents) {
    var v = (Number(cents) || 0) / 100;
    var dec = v.toFixed(2), nod = String(Math.round(v));
    var map = {
      amount: dec,
      amount_no_decimals: nod,
      amount_with_comma_separator: dec.replace('.', ','),
      amount_no_decimals_with_comma_separator: nod
    };
    return MONEY.replace(/\{\{\s*(amount(?:_no_decimals)?(?:_with_comma_separator)?)\s*\}\}/g, function (m, k) {
      return map[k] != null ? map[k] : m;
    });
  }

  function keySel(key) {
    return '[data-wb-cart-row][data-key="' + (window.CSS && CSS.escape ? CSS.escape(key) : key) + '"]';
  }

  function apply(cart) {
    if (!cart || cart.status) return;

    document.querySelectorAll('[data-wb-cart-count]').forEach(function (el) {
      el.textContent = cart.item_count;
    });
    document.querySelectorAll('[data-wb-cart-pcount]').forEach(function (el) {
      el.textContent = '(' + cart.item_count + ')';
    });
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = cart.item_count;
      if (cart.item_count > 0) el.removeAttribute('hidden');
      else el.setAttribute('hidden', '');
    });

    if (!cart.items.length) { window.location.reload(); return; }

    var alive = {};
    cart.items.forEach(function (it) {
      alive[it.key] = 1;
      var row = document.querySelector(keySel(it.key));
      if (!row) return;
      row.classList.remove('is-busy');
      var q = row.querySelector('[data-wb-cart-qty]');
      if (q && document.activeElement !== q) q.value = it.quantity;
      var unit = row.querySelector('[data-wb-cart-unit]');
      if (unit) unit.textContent = fmt(it.final_price);
      var line = row.querySelector('[data-wb-cart-line]');
      if (line) line.textContent = fmt(it.final_line_price);
      var dec = row.querySelector('[data-wb-cart-dec]');
      if (dec) dec.disabled = it.quantity <= 1;
    });

    document.querySelectorAll('[data-wb-cart-row]').forEach(function (row) {
      if (!alive[row.getAttribute('data-key')]) row.remove();
    });

    var total = document.querySelector('[data-wb-cart-total]');
    if (total) total.textContent = fmt(cart.total_price);

    var msg = document.querySelector('[data-wb-cart-shipmsg]');
    var fill = document.querySelector('[data-wb-cart-shipfill]');
    if (TH) {
      var left = TH - cart.total_price;
      if (msg) {
        msg.textContent = left > 0
          ? 'Spend ' + fmt(left) + ' more for free shipping!'
          : "You've qualified for free shipping!";
      }
      if (fill) fill.style.width = Math.max(0, Math.min(100, (cart.total_price / TH) * 100)).toFixed(2) + '%';
    }

    if (window.WB && window.WB.cart) window.WB.cart.refresh();
  }

  function change(key, qty, row) {
    if (row) row.classList.add('is-busy');
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (cart && cart.status) { window.location.reload(); return; }
        apply(cart);
      })
      .catch(function () { window.location.reload(); });
  }

  form.addEventListener('click', function (e) {
    var row = e.target.closest('[data-wb-cart-row]');
    if (!row) return;
    var key = row.getAttribute('data-key');
    var inp = row.querySelector('[data-wb-cart-qty]');
    var q = parseInt(inp && inp.value, 10) || 1;

    if (e.target.closest('[data-wb-cart-inc]')) { e.preventDefault(); change(key, q + 1, row); return; }
    if (e.target.closest('[data-wb-cart-dec]')) { e.preventDefault(); if (q > 1) change(key, q - 1, row); return; }
    if (e.target.closest('[data-wb-cart-rm]')) { e.preventDefault(); change(key, 0, row); return; }
  });

  form.addEventListener('change', function (e) {
    var inp = e.target.closest('[data-wb-cart-qty]');
    if (!inp) return;
    var row = inp.closest('[data-wb-cart-row]');
    var q = parseInt(inp.value, 10);
    if (isNaN(q) || q < 0) q = 1;
    change(row.getAttribute('data-key'), q, row);
  });

  form.addEventListener('keydown', function (e) {
    var inp = e.target.closest('[data-wb-cart-qty]');
    if (inp && e.key === 'Enter') { e.preventDefault(); inp.blur(); }
  });

  /* ---------- 右栏折叠条（Order Note / Coupon） ---------- */
  document.querySelectorAll('[data-wb-acc]').forEach(function (acc) {
    var btn = acc.querySelector('[data-wb-acc-toggle]');
    var body = acc.querySelector('.wb-cart__accbody');
    if (!btn || !body) return;
    btn.addEventListener('click', function () {
      var open = btn.getAttribute('aria-expanded') === 'true';
      btn.setAttribute('aria-expanded', open ? 'false' : 'true');
      acc.classList.toggle('is-open', !open);
      body.hidden = open;
      if (!open) {
        var f = body.querySelector('textarea, input');
        if (f) setTimeout(function () { f.focus(); }, 60);
      }
    });
  });

  /* ---------- 优惠码 ---------- */
  var disc = document.querySelector('[data-wb-cart-disc]');
  if (disc) {
    var discInput = disc.querySelector('.wb-cart__discinput');
    var applyCode = function () {
      var code = (discInput && discInput.value || '').trim();
      if (!code) { if (discInput) discInput.focus(); return; }
      window.location.href = '/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(window.location.pathname);
    };
    var discBtn = disc.querySelector('[data-wb-cart-discapply]');
    if (discBtn) discBtn.addEventListener('click', applyCode);
    if (discInput) discInput.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); applyCode(); } });
  }

  /* ---------- 订单备注：失焦自动保存 ---------- */
  var pageNote = document.querySelector('[data-wb-cart-note]');
  if (pageNote) {
    var pageNoteLast = pageNote.value;
    pageNote.addEventListener('blur', function () {
      var v = pageNote.value;
      if (v === pageNoteLast) return;
      pageNoteLast = v;
      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ note: v })
      }).catch(function () {});
    });
  }
})();

/* 32. 搜索浮层：点顶栏放大镜下拉展开（对齐演示站交互） */
(function () {
  var sd = document.querySelector('[data-wb-sd]');
  if (!sd) return;

  var hd       = document.querySelector('[data-hd]');
  var input    = sd.querySelector('[data-wb-sd-input]');
  var emptyBox = sd.querySelector('[data-wb-sd-empty]');
  var resBox   = sd.querySelector('[data-wb-sd-results]');
  var resetBtn = sd.querySelector('[data-wb-sd-reset]');
  var content  = sd.querySelector('[data-wb-sd-content]');
  var triggers = document.querySelectorAll('[data-wb-sd-open]');
  var reduce   = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var cur      = sd.getAttribute('data-currency') || 'USD';

  var nf = null;
  try { nf = new Intl.NumberFormat('en-US', { style: 'currency', currency: cur }); } catch (e) { nf = null; }
  function money(v) {
    var n = parseFloat(v);
    if (!isFinite(n)) return '';
    return nf ? nf.format(n) : '$' + n.toFixed(2);
  }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  var isOpen = false, prevFocus = null, typeTimer = null, typed = false, reqId = 0, debounce = null;

  function setTop() {
    var top = 0;
    if (hd) top = Math.max(0, Math.round(hd.getBoundingClientRect().bottom));
    sd.style.setProperty('--sd-top', top + 'px');
  }

  /* 打字机效果的 placeholder（演示站同款） */
  function typewrite() {
    if (typed || reduce || !input) return;
    var full = input.getAttribute('data-wb-sd-ph') || input.getAttribute('placeholder') || '';
    if (!full) return;
    var i = 0;
    input.setAttribute('placeholder', '');
    clearInterval(typeTimer);
    typeTimer = setInterval(function () {
      i += 1;
      input.setAttribute('placeholder', full.slice(0, i));
      if (i >= full.length) { clearInterval(typeTimer); typed = true; }
    }, 55);
  }

  function showEmpty() {
    if (resBox) { resBox.hidden = true; resBox.innerHTML = ''; }
    if (emptyBox) emptyBox.hidden = false;
    if (resetBtn) resetBtn.hidden = !(input && input.value);
  }

  function open() {
    if (isOpen) return;
    isOpen = true;
    prevFocus = document.activeElement;
    setTop();
    sd.classList.add('is-open');
    sd.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('wb-sd-open');
    Array.prototype.forEach.call(triggers, function (t) { t.setAttribute('aria-expanded', 'true'); });
    if (content) content.scrollTop = 0;
    window.setTimeout(function () {
      if (input) { try { input.focus({ preventScroll: true }); } catch (e) { input.focus(); } }
      typewrite();
    }, reduce ? 0 : 140);
  }

  function close() {
    if (!isOpen) return;
    isOpen = false;
    clearInterval(typeTimer);
    sd.classList.remove('is-open');
    sd.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('wb-sd-open');
    Array.prototype.forEach.call(triggers, function (t) { t.setAttribute('aria-expanded', 'false'); });
    if (prevFocus && prevFocus.focus) { try { prevFocus.focus({ preventScroll: true }); } catch (e) {} }
  }

  /* 即时结果 */
  function productRows(list) {
    return list.map(function (p) {
      var img = p.image || p.featured_image || '';
      var cmp = parseFloat(p.compare_at_price_max || 0);
      return '<a class="wb-sd__rrow" href="' + esc(p.url) + '">' +
        '<span class="wb-sd__rimg">' + (img ? '<img src="' + esc(img) + '" alt="" width="80" height="80" loading="lazy">' : '') + '</span>' +
        '<span class="wb-sd__rinfo">' +
          '<span class="wb-sd__rname">' + esc(p.title) + '</span>' +
          '<span class="wb-sd__rprice"><b>' + esc(money(p.price)) + '</b>' +
            (cmp > parseFloat(p.price) ? '<s>' + esc(money(cmp)) + '</s>' : '') +
          '</span>' +
        '</span>' +
      '</a>';
    }).join('');
  }

  function render(j, q) {
    var r = (j && j.resources && j.resources.results) || null;
    var queries = (r && r.queries) || [];
    var cols    = (r && r.collections) || [];
    var prods   = (r && r.products) || [];
    var html = '';

    if (queries.length) {
      html += '<div class="wb-sd__block"><h3 class="wb-sd__bh">Suggestions</h3><div class="wb-sd__ql">' +
        queries.map(function (q2) {
          return '<a href="' + esc(q2.url) + '">' + (q2.styled_text || esc(q2.text)) + '</a>';
        }).join('') + '</div></div>';
    }
    if (cols.length) {
      html += '<div class="wb-sd__block"><h3 class="wb-sd__bh">Collections</h3><div class="wb-sd__ql">' +
        cols.map(function (c) { return '<a href="' + esc(c.url) + '">' + esc(c.title) + '</a>'; }).join('') + '</div></div>';
    }
    if (prods.length) {
      html += '<div class="wb-sd__block"><h3 class="wb-sd__bh">Products</h3>' + productRows(prods) + '</div>';
    }
    if (!html) {
      html = '<div class="wb-sd__block"><h3 class="wb-sd__bh">No results</h3>' +
        '<p class="wb-sd__rempty">No products found for &ldquo;' + esc(q) + '&rdquo;. Press Enter to search anyway.</p></div>';
    }

    if (!resBox) return;
    resBox.innerHTML = html;
    resBox.hidden = false;
    if (emptyBox) emptyBox.hidden = true;
  }

  function search(q) {
    var id = ++reqId;
    var url = '/search/suggest.json?q=' + encodeURIComponent(q) +
      '&resources[type]=product,collection,query&resources[limit]=6';
    fetch(url, { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (j) {
        if (id !== reqId) return;
        /* 接口不可用（例如店铺还在密码保护期）时退回默认模块，而不是甩一句“无结果” */
        if (!j) { showEmpty(); return; }
        render(j, q);
      })
      .catch(function () { if (id === reqId) showEmpty(); });
  }

  /* 开 / 关 */
  Array.prototype.forEach.call(triggers, function (t) {
    t.addEventListener('click', function (e) {
      e.preventDefault();
      open();
    });
  });
  sd.addEventListener('click', function (e) {
    if (e.target.closest('[data-wb-sd-close]')) { e.preventDefault(); close(); }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && isOpen) close();
  });
  /* 打开购物车抽屉时收起搜索，避免两层叠一起 */
  document.querySelectorAll('[data-wb-cd-open]').forEach(function (b) {
    b.addEventListener('click', function () { if (isOpen) close(); });
  });
  window.addEventListener('resize', function () { if (isOpen) setTop(); });

  /* 输入 → 防抖请求即时结果 */
  if (input) {
    input.addEventListener('input', function () {
      var q = input.value.trim();
      if (resetBtn) resetBtn.hidden = !input.value;
      clearTimeout(debounce);
      if (!q) { reqId += 1; showEmpty(); return; }
      debounce = setTimeout(function () { search(q); }, 260);
    });
    input.addEventListener('search', function () {
      if (!input.value) showEmpty();
    });
  }
  if (resetBtn) {
    resetBtn.addEventListener('click', function () {
      if (!input) return;
      input.value = '';
      resetBtn.hidden = true;
      reqId += 1;
      showEmpty();
      input.focus();
    });
  }
})();

/* ==========================================================================
   公告条：多条消息时淡入轮播（单条不启动）
   演示站这个组件本身是 swiper，只是配了 1 条消息；这里用同一网格位叠放，
   高度不会跟着消息长短跳。悬停 / 页面隐藏 / 系统偏好减少动效时暂停。
   ========================================================================== */
(function () {
  var root = document.querySelector('[data-wb-announce]');
  if (!root) return;
  var msgs = root.querySelectorAll('.wb-announce__msg');
  if (msgs.length < 2) return;
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var i = 0, timer = null;

  function show(n) {
    for (var k = 0; k < msgs.length; k++) {
      msgs[k].classList.toggle('is-on', k === n);
    }
  }
  function next() { i = (i + 1) % msgs.length; show(i); }
  function start() { if (timer) return; timer = setInterval(next, 5200); }
  function stop() { clearInterval(timer); timer = null; }

  root.addEventListener('mouseenter', stop);
  root.addEventListener('mouseleave', start);
  root.addEventListener('focusin', stop);
  root.addEventListener('focusout', start);
  document.addEventListener('visibilitychange', function () {
    if (document.hidden) stop(); else start();
  });
  start();
})();

/* ==========================================================================
   侧边悬浮栏：Newsletter 弹窗 / 优惠码面板 / 回顶部 / 手机端半藏推出
   ========================================================================== */
(function () {
  var root = document.querySelector('[data-wb-dock]');
  if (!root) return;

  var stack = root.querySelector('[data-wb-dock-stack]');
  var backdrop = root.querySelector('[data-wb-dock-backdrop]');
  var topBtn = root.querySelector('[data-wb-dock-top]');
  var peek = root.querySelector('[data-wb-dock-peek]');
  var triggers = root.querySelectorAll('[data-wb-dock-open]');
  var panels = root.querySelectorAll('[data-wb-dock-panel]');
  var threshold = parseInt(root.getAttribute('data-threshold'), 10) || 600;
  var openKey = null;
  var lastFocus = null;

  /* ---------- 回顶部 ---------- */
  function onScroll() {
    if (!topBtn) return;
    var show = (window.pageYOffset || document.documentElement.scrollTop) > threshold;
    topBtn.classList.toggle('is-visible', show);
    topBtn.setAttribute('aria-hidden', show ? 'false' : 'true');
    topBtn.tabIndex = show ? 0 : -1;
  }
  if (topBtn) {
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
    topBtn.addEventListener('click', function () {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
  }

  /* ---------- 面板开关 ---------- */
  function panelOf(key) {
    for (var i = 0; i < panels.length; i++) {
      if (panels[i].getAttribute('data-wb-dock-panel') === key) return panels[i];
    }
    return null;
  }
  function setTriggerState(key, on) {
    for (var i = 0; i < triggers.length; i++) {
      if (triggers[i].getAttribute('data-wb-dock-open') === key) {
        triggers[i].setAttribute('aria-expanded', on ? 'true' : 'false');
      }
    }
  }
  function closeAll(restoreFocus) {
    if (!openKey) return;
    var p = panelOf(openKey);
    if (p) {
      p.classList.remove('is-open');
      p.setAttribute('aria-hidden', 'true');
    }
    setTriggerState(openKey, false);
    openKey = null;
    if (backdrop) backdrop.classList.remove('is-visible');
    document.documentElement.style.overflow = '';
    if (restoreFocus && lastFocus && lastFocus.focus) lastFocus.focus();
  }
  function open(key, trigger) {
    var p = panelOf(key);
    if (!p) return;
    if (openKey === key) { closeAll(true); return; }
    closeAll(false);
    openKey = key;
    lastFocus = trigger || null;
    p.classList.add('is-open');
    p.setAttribute('aria-hidden', 'false');
    setTriggerState(key, true);
    // 只有居中弹窗需要遮罩；优惠面板是贴着图标的 popover
    if (backdrop && key === 'nl') backdrop.classList.add('is-visible');
    if (key === 'nl') document.documentElement.style.overflow = 'hidden';
    var closeBtn = p.querySelector('[data-wb-dock-close]');
    if (closeBtn && key !== 'nl') closeBtn.focus({ preventScroll: true });
  }

  for (var i = 0; i < triggers.length; i++) {
    (function (btn) {
      btn.addEventListener('click', function () {
        open(btn.getAttribute('data-wb-dock-open'), btn);
      });
    })(triggers[i]);
  }
  root.querySelectorAll('[data-wb-dock-close]').forEach(function (btn) {
    btn.addEventListener('click', function () { closeAll(true); });
  });
  if (backdrop) backdrop.addEventListener('click', function () { closeAll(true); });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && openKey) closeAll(true);
  });

  // 点面板外部关闭（优惠面板是 popover，需要这条）
  document.addEventListener('click', function (e) {
    if (!openKey || openKey === 'nl') return;
    if (root.contains(e.target)) return;
    if (e.target.closest && e.target.closest('[data-wb-dock]')) return;
    closeAll(true);
  });

  /* ---------- 手机端半藏推出 ---------- */
  if (peek && stack) {
    peek.addEventListener('click', function () {
      stack.classList.add('is-open');
      peek.setAttribute('aria-expanded', 'true');
    });
    document.addEventListener('click', function (e) {
      if (!stack.classList.contains('is-open')) return;
      if (root.contains(e.target)) return;
      stack.classList.remove('is-open');
      peek.setAttribute('aria-expanded', 'false');
    });
  }

  /* ---------- 复制优惠码 ---------- */
  function copyText(text) {
    if (navigator.clipboard && navigator.clipboard.writeText) {
      return navigator.clipboard.writeText(text);
    }
    return new Promise(function (resolve, reject) {
      var ta = document.createElement('textarea');
      ta.value = text;
      ta.style.position = 'fixed';
      ta.style.opacity = '0';
      document.body.appendChild(ta);
      ta.select();
      try { document.execCommand('copy'); resolve(); } catch (err) { reject(err); }
      document.body.removeChild(ta);
    });
  }
  root.querySelectorAll('[data-wb-copy]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var code = btn.getAttribute('data-wb-copy') || '';
      var label = btn.querySelector('.wb-dock__copy-t');
      copyText(code).then(function () {
        btn.classList.add('is-copied');
        if (label) label.textContent = 'Copied';
        setTimeout(function () {
          btn.classList.remove('is-copied');
          if (label) label.textContent = 'Copy';
        }, 1800);
      }).catch(function () {
        if (label) label.textContent = 'Copy manually';
      });
    });
  });

  /* ---------- 订阅成功回跳：自动打开弹窗并显示成功文案 ---------- */
  if (/[?&]customer_posted=true/.test(location.search)) {
    var nlPanel = panelOf('nl');
    if (nlPanel) open('nl', null);
  }
})();
